export default {
  switch_to_light_mode: 'Switch to light mode',
  switch_to_dark_mode: 'Switch to dark mode',
  app_name: 'My Local Gun Shop | Buy Guns Online',
  coming_soon: 'Coming Soon',
  stay_tuned: 'Stay tuned!',
  scroll_to_top: 'Scroll to top',
  success: 'Success',
  fail: 'Fail',
  yes: 'Yes',
  no: 'No',
  loader_text: 'Loading...',
  active: 'Active',
  inactive: 'Inactive',
  reload: 'Reload',
  update: 'Update',
  continue: 'Continue',
  save_changes: 'Save Changes',
  copied_to_clipboard: 'Copied to clipboard',
  copy_slug: 'Copy Slug',
  invite: 'Invite',
  invite_ffl: 'Invite FFL',
  invite_customer: 'Invite Customer',
  invite_customer_success_message: 'Invitation sent successfully.',
  add: 'Add',
  create: 'Create',
  select: 'Select',
  select_or_type: 'Select or type',
  no_data_exist: 'No Data Exist',
  no_key_data_found: 'No {{ key }} Found',
  click_here_to_action: 'Click here to {{ action }}',
  click_here: 'Click here',
  something_went_wrong: 'Something went wrong!',
  maintenance_title: "We'll be right back",
  maintenance_subtitle: "We're performing scheduled maintenance.",
  maintenance_refresh_note: "This page will refresh automatically once we're back.",
  maintenance_support_note: 'Need help right now? Email',
  maintenance_message_1: 'Performing scheduled maintenance…',
  maintenance_message_2: 'Tidying up a few things…',
  maintenance_message_3: 'Almost ready…',
  offline_title: "You're offline",
  offline_subtitle: 'Please check your internet connection.',
  offline_resume_note: "This page will resume automatically once you're back online.",
  offline_message_1: 'Checking your connection…',
  offline_message_2: 'Waiting for network…',
  logout_success_msg: 'You have logged out successfully',
  email_address: 'Email Address',
  password: 'Password',
  reset_password: 'Reset Password',
  create_password: 'Create Password',
  old_password: 'Old Password',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  confirm_payment_success_msg: 'Payment completed successfully',
  delete_confirm_title: 'DELETE THIS {{key}}?',
  delete_confirm_msg: 'Are you sure, once you delete you can’t recover this {{key}}.',
  sold_confirm_title: 'SOLD THIS {{key}}?',
  geenral_confirm_msg: 'Are you sure, this action is not reversible.',
  no_cancel_btn_text: 'No, Cancel',
  yes_confirm_delete_btn_text: 'Yes, Delete',
  yes_confirm_sold_btn_text: 'Yes, Sold',
  yes_confirm_reset_btn_text: 'Yes, Reset',
  yes_confirm_logout_btn_text: 'Yes, Logout',
  password_min_length: 'Minimum {{count}} characters required.',
  password_max_length: 'Maximum {{count}} characters allowed.',
  password_lowercase_required: 'Add at least one lowercase letter.',
  password_uppercase_required: 'Add at least one uppercase letter.',
  password_number_required: 'Add at least one number.',
  password_special_required: 'Add at least one special character.',
  password_no_spaces: 'Spaces are not allowed.',
  password_same_as_old: 'New password must differ from old password.',
  password_not_match: 'Passwords do not match.',
  password_rule_hint: '8–15 chars with upper, lower, number & symbol.',
  personal_number_hint: 'For internal usage only',
  submit: 'Submit',
  submit_sign_up_form: 'Submit Sign Up Form',
  send: 'Send',
  back: 'Back',
  reply: 'Reply',
  back_to_login: 'Back to Login',
  login: 'Login',
  login_to_sell_a_firearm: 'Login to Sell a Firearm',
  sell_a_firearm: 'Sell a Firearm',
  sign_in_and_start_listing: 'Login & Start Listing',
  start_listing: 'Start Listing',
  sign_up: 'Sign-Up',
  sign_in: 'Sign In',
  ffl_sign_in: 'FFL Sign In',
  join_as_an_ffl: 'Join as an FFL',
  are_you_an_ffl: 'Are you an FFL?',
  login_or_create_an_account: 'Login or Create an account',
  buyer: 'Buyer',
  for_individual_buyers_caps: 'For Individual Buyers',
  for_federal_firearm_licensees_caps: 'For Federal Firearm Licensees',
  welcome_back: 'Welcome Back',
  login_to_buy_and_manage: 'Login to buy and manage your listings',
  ffl_dealer_sign_in: 'FFL Dealer Sign In',
  access_your_dealer_dashboard: 'Access your dealer dashboard and pending transfers',
  keep_me_signed_in: 'Keep me signed in',
  marketing_opt_in_label:
    'Send me email and SMS notifications, including order updates, deals and offers. You can change this anytime in your settings.',
  customer_marketing_opt_in_label: 'Customer agrees to receive email and SMS notifications',
  new_to_mlgs: 'New to My Local Gun Shop?',
  dont_have_ffl_access_yet: "Don't have an FFL access yet?",
  apply_now: 'Apply Now',
  are_you_an_ffl_dealer_q: 'Are you an FFL dealer?',
  join_our_network: 'Join our network of verified dealers.',
  join_as_ffl: 'Join as FFL',
  explore_customer_benefits: 'Explore the benefits of a customer',
  track_items_promo: 'Track items, Shops and sell your guns to FFLs.',
  buyer_login: 'Buyer Login',
  customer_signup: 'Customer Signup',
  ffl_signup_text: 'FFL Signup',
  max_file_intruction_msg: 'You can upload a maximum of {{key}} files only.',
  max_file_count_excced_error_msg: 'You can only upload {{key}} more file(s)',
  file_size_excced_error_msg: 'File size must be less than {{key}} MB',
  allowed_file_type_error_msg: 'Allowed types: {{- key}}',
  exact_image_dimension_error_msg: 'Image must be exactly {{width}}x{{height}} px',
  min_image_dimension_error_msg: 'Image must be at least {{width}}x{{height}} px',
  file_upload_failed_error_msg: 'Upload Failed',
  file_upload_success_msg: 'Upload Successful',
  image_dimension_instruction_msg: '(Recommended image at least: {{width}}x{{height}} px)',
  product_dimension_instruction_msg: 'Image resolution should be like: {{width}}x{{height}} px)',
  file: 'File',
  'create_account?': 'Create Account?',
  create_account: 'Create Account',
  'forgot_password?': 'Forgot Password?',
  forgot_password: 'Forgot Password',
  find_your_account: 'FIND YOUR ACCOUNT',
  no_options: 'No Options',
  find_your_account_desc: 'Forgot your password? Enter your email to receive a reset link.',
  email_sent: 'EMAIL SENT',
  enter_your_email: 'Enter your email address',
  email_sent_message: 'We sent an email to {{email}} with a link to get back into your account',
  redirecting_to_login_in: 'Redirecting to login in',
  seconds: 'seconds',
  logout: 'Logout',
  forgot_password_instruction_msg: 'Enter your email to reset password',
  go_back: 'Go Back',
  page_not_found: 'Page Not Found',
  hide: 'Hide',
  unhide: 'Unhide',
  show: 'Show',
  public: 'Public',
  private: 'Private',
  edit: 'Edit',
  details: 'Details',
  delete: 'Delete',
  list: 'List',
  filter: 'Filter',
  reset: 'Reset',
  clear: 'Clear',
  apply: 'Apply',
  confirm: 'Confirm',
  cancel: 'Cancel',
  profile_image: 'Profile Image',
  your_selected_ffl_for_shipping: 'Your selected FFL for Shipping',
  follow_your_favorite_ffl: 'Follow your favorite FFL',
  saved_items: 'Saved Items',
  help_and_support: 'Help & Support',
  help_and_support_subtitle: 'Resolve issues & get support',
  live: 'Live',
  // header live ticker - each line is prefixed with the bold heading returned by the API
  live_update_new_product: 'listed {{time}} for {{price}}',
  live_update_new_product_without_price: 'listed {{time}}',
  live_update_new_ffl: 'listed {{total}} items {{time}}',
  live_update_new_ffl_joined: 'joined {{time}}',
  live_update_discounted_product: 'just discounted {{total}} products',
  live_update_coupon: 'just made this coupon {{code}}',
  profile: 'Profile',
  profile_and_settings: 'Profile & Settings',
  manage_profile_and_addresses: 'Manage Profile & Addresses',
  addresses: 'Addresses',
  addresses_ffl_selection_tooltip:
    "You choose the FFL and address together as one entry. Whichever one you pick at checkout, that FFL will be used for the order's firearm transfer.",
  manage_profile_reviews: 'See all the reviews you have added',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  approve: 'Approve',
  reject: 'Reject',
  reset_settings_confirm_msg: 'You want to reset settings?',
  confirm_title: 'Are you sure?',
  confirm_title_key_msg: 'You want to {{key}}?',
  confirm_logout_msg: 'You want to log out?',
  registration_completed_msg: 'Registration completed',
  registration_completed_instruction_msg:
    'We’ve emailed you a verification link. Click the link to verify your email and activate your account.',
  setting_reset_success_msg: 'Settings Reset Successfully',
  order_placed_success_msg: 'Order placed Successfully',
  sent_successfull_message: '{{key}} Sent Successfully',
  added_draft_successfull_message: '{{key}} added as draft successfully',
  drafted_successfull_message: '{{key}} Drafted Successfully',
  deleted_successfull_message: '{{key}} Deleted Successfully',
  added_successfull_message: '{{key}} Created Successfully',
  edit_successfull_message: '{{key}} Updated Successfully',
  submit_successfull_message: '{{key}} Submitted Successfully',
  verified_successfull_message: '{{key}} Verified Successfully',
  required_error_msg: '{{field_name}} is required',
  two_of_one_required_error_msg: 'At least one {{fields}} is required.',
  greater_equal_error_msg: '{{field_name1}} should be greater than or equal to the {{field_name2}}',
  less_equal_error_msg: '{{field_name1}} should be less than or equal to the {{field_name2}}',
  greater_than_error_msg: '{{field_name1}} should be greater than {{field_name2}}',
  less_than_error_msg: '{{field_name1}} should be less than {{field_name2}}',
  invalid_error_msg: '{{field_name}} is invalid',
  must_be_at_least_18_years_old: 'Must be at least 18 years old',
  value_exist_error_msg: '{{field_name}} is already exist',
  send_reset_link: 'Send Reset Link',
  table_settings: 'Table Settings',
  column_name: 'Column Name',
  allow_list: 'Allow List',
  allow: 'Allow',
  allow_filter: 'Allow Filter',
  export_data: 'Export Data',
  export: 'Export',
  csv: 'CSV',
  print: 'Print',
  excel: 'Excel',
  pdf: 'PDF',
  copy: 'Copy',
  main: 'Main',
  manage: 'Manage',
  more: 'More',
  role_all: 'Role: All',
  status_all: 'Status: All',
  allow_filter_all: 'Allow Filter: All',
  category_all: 'Category: All',
  sub_category_all: 'Sub Category: All',
  ffl_all: 'FFL: All',
  FFL: 'FFL',
  ffl_status_all: 'FFL Status: All',
  state_all: 'State: All',
  search_text: 'Search...',
  search_order: 'Search order...',
  approved_ffls: 'Approved FFLS',
  pending_ffls: 'Pending FFLS',
  subscriptions: 'Subscriptions',
  no_fields_exist: 'No Fields Exist',
  store_pages: 'Store Pages',
  delete_image_confirm_text: 'delete image',
  delete_ffl_confirm_text: 'delete ffl',
  delete_customer_confirm_text: 'delete customer',
  delete_customer_group_confirm_text: 'delete customer group',
  delete_product_confirm_text: 'delete product',
  delete_category_confirm_text: 'delete category',
  delete_url_rewrite_confirm_text: 'delete url rewrite',
  delete_blog_category_confirm_text: 'delete blog category',
  update_ffl_status: 'Update FFL Status',
  ffl_status: 'FFL Status',
  remarks: 'Remarks',
  users: 'Users',
  user: 'User',
  home: 'Home',
  name: 'Name',
  expiry_date: 'Expiry Date',
  name_on_card: 'Name on Card',
  card_number: 'Card Number',
  CVV: 'CVV',
  first_name: 'First Name',
  last_name: 'Last Name',
  receiver_first_name: 'Receiver First Name',
  receiver_last_name: 'Receiver Last Name',
  date_of_birth: 'Date Of Birth',
  logo: 'Logo',
  image: 'Image',
  media: 'Media',
  no_images: 'No Images',
  album_images: 'Album Images',
  album_images_tooltip:
    'Photos or videos of your store shown to customers. Upload up to 10, cropped to 16:9.',
  upload_main_image: 'Upload Main Image',
  general_information: 'General Information',
  Sidebar_menu_configuration: 'Sidebar Menu Configuration',
  ffl_information: 'FFL Information',
  change_password: 'Change Password',
  verify_account: 'Verify Account',
  decline_account: 'Decline Account',
  ffl_detail: 'FFL Detail',
  employees: 'Employees',
  employee: 'Employee',
  create_new_record: 'Create New {{ key }}',
  edit_record: 'Edit {{key}}',
  employee_page_description: 'Manage all your employees below.',
  roles: 'Roles',
  role_page_description: 'Manage all your roles below.',
  permissions: 'Permissions',
  url_rewrite: 'URL Rewrites',
  url_rewrite_description: 'Manage all your url rewrite below.',
  target: 'Target',
  request_path: 'Request Path',
  target_path: 'Target Path',
  edit_url_rewrite: 'Edit URL Rewrite',
  add_new_url_rewrite: 'Add New URL Rewrite',
  customer: 'Customer',
  customers: 'Customers',
  groups: 'Groups',
  customer_groups: 'Customer Groups',
  customer_group: 'Customer Group',
  customer_detail: 'Customer Detail',
  edit_customer: 'Edit Customer',
  update_customer_group: 'Update Group',
  add_to_group: 'Add to Group',
  remove_from_group: 'Remove from Group',
  max_customer_selection_error: 'Maximum {{max}} customers can be selected at a time',
  select_customer_group: 'Select Customer Group',
  selected_customers: 'Selected Customers',
  role: 'Select Role',
  role_label: 'Role',
  status: 'Status',
  tracking: 'Tracking',
  "FFL's": "FFL'S",
  ffl_page_description: 'Manage all your FFL’s below.',
  contact_info: 'Contact Info',
  personal_contact_info: 'Personal Contact Info',
  fastbound_setting: 'Fastbound Setting',
  bio: 'Bio',
  company_hours: 'Company Hours',
  update_ffl: 'Update FFL',
  business_name: 'Business Name',
  personal_name: 'Personal Name',
  personal_phone: 'Personal Phone',
  business_phone: 'Business Phone',
  trial_end_date: 'Trial End Date',
  email: 'Email',
  federal_firearms_license: 'Federal Firearms License (FFL)#',
  old_address: 'Old Address',
  street_address: 'Street Address',
  address_line_1: 'Address Line 1',
  city: 'City',
  zip_code: 'Zip Code',
  phone_number: 'Phone Number',
  personal_number: 'Personal Number',
  transfer_fee: 'Transfer Fee*(Numbers Only)',
  payment_types: 'Payment Types',
  website: 'Website',
  website_url: 'Website url',
  seller_ships: 'This Seller Ships?',
  hours: 'Hours',
  speciality: 'Speciality',
  speciality_if_any: 'Speciality (if any)',
  services: 'Services',
  service_provided_at_shop: 'Service provided at shop',
  subscription: 'Subscription',
  subscription_period: 'Subscription Period',
  trial_ends: 'Trial Ends',
  action: 'Action',
  view_all: 'View All',
  captcha_verification: 'Captcha verification',
  captcha_load_failed: 'Captcha failed to load.',
  edit_ffl: 'Edit FFL',
  ffl_signup: 'FFL Sign - Up',
  ffl_login: 'FFL LOG IN',
  firearm_trade_in: 'Firearm Trade-in',
  trade_in_items: 'Trade-In Items',
  find_an_ffl: 'Find an FFL',
  track_order: 'Track Order',
  valid_till_date: 'Valid till {{date}}',
  live_support_available: 'Live Support Available',
  login_instruction_1: 'Start Listing Firearms Today',
  login_instruction_2: 'FOCUS ON MAKING MONEY',
  login_instruction_3: 'NOT ENDLESSLY SPENDING IT.',
  SIGN_UP: 'SIGN UP',
  customer_sign_up: 'Customer Sign-Up',
  ffl_signup_instruction:
    'Complete the form below and a member of our sales team will contact you to discuss the next steps.',
  fenderal_firearms_license: 'Fenderal Firearms License',
  ffl: 'FFL',
  ffl_no: 'FFL Number',
  facebook_username: 'Facebook',
  instagram_handle: 'Instagram',
  twitter_handle: 'Twitter/X',
  youtube_channel: 'Youtube',
  channel_id: 'Channel Id',
  do_you_ship: 'Do you ship?',
  working_hours: 'Working Hours',
  state: 'State',
  zipcode: 'Zip code',
  parent_category: 'Parent Category',
  subcategory: 'Subcategory',
  categories: 'Categories',
  x_of_products: '# Of Products',
  x_of_ffl: '# of FFL',
  x_of_key: '# of {{key}}',
  number_of_key: 'Number of {{key}}',
  category_list: 'Category List',
  created_at: 'Created At',
  received_at: 'Received At',
  created_by: 'Created By',
  add_new_category: 'Add New Category',
  add_category: 'Add Category',
  category_name: 'Category Name',
  sub_category_name: 'Sub-Category Name',
  edit_category: 'Edit Category',
  add_new_customer_group: 'Add New Customer Group',
  edit_customer_group: 'Edit Customer Group',
  integrations: 'Integrations',
  fastbound_account_settings: 'Fastbound Account Settings',
  account: 'Account',
  size_error: 'Image must be smaller',
  avatar_size: 'Image size 2MB',
  avatar_file_format_error: 'Incorrect file format image must',
  avatar_file_format: '.jpeg, .png',
  expiration_date: 'Expiration Date',
  product_list: 'Product List',
  products: 'Products',
  products_small: 'products',
  product: 'Product',
  product_page_discription: 'Manage all your Products below.',
  merchandise_page_description: 'Manage all your Merchandise products below.',
  firearms_page_description: 'Manage all your Firearms products below.',
  ammo_page_description: 'Manage all your Ammo products below.',
  silencers_page_description: 'Manage all your Silencer products below.',
  firearms: 'Firearms',
  ammo: 'Ammo',
  silencers: 'Silencers',
  product_general_section: 'General',
  product_desription_section: 'Description',
  product_price_section: 'Price',
  product_shipping_section: 'Shipping',
  product_meta_section: 'Meta',
  product_setting_section: 'Settings',
  featured: 'Featured',
  new: 'New',
  off: 'OFF',
  meta_title: 'Meta Title',
  meta_keywords: 'Meta Keywords',
  meta_description: 'Meta Description',
  manufacturer: 'Manufacturer',
  manufact: 'Manufact.',
  ordered: 'Ordered',
  no_orders: 'No Orders',
  all_orders: 'All Orders',
  'manufacturer(s)': 'Manufacturer(s)',
  modal: 'Modal',
  caliber: 'Caliber',
  caliber_short: 'Cal',
  caliber_gauge: 'Caliber/Gauge',
  weight: 'Weight',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  shipping_type: 'Shipping Type',
  shipping_cost: 'Shipping Cost',
  delivery: 'Delivery',
  category: 'Category',
  manufacturers: 'Manufacturers',
  add_manufacturer: 'Add Manufacturer',
  edit_manufacturer: 'Edit Manufacturer',
  manufacturer_name: 'Manufacturer Name',
  manufacturer_page_description: 'Manage all your manufacturers below.',
  select_category: 'Select Category',
  select_sub_category: 'Select Sub-Category',
  listing_status: 'Listing Status',
  listing_status_all: 'Listing Status: All',
  x_of_sold: '# Of Sold',
  no_products_listed: 'No products listed',
  x_active_products_listed: '{{total}} active product(s) listed',
  banner: 'Banner',
  banners: 'Banners',
  add_banner: 'Add Banner',
  edit_banner: 'Edit Banner',
  banner_name: 'Banner Name',
  banner_page_description: 'Manage all your home page banners below.',
  max_active_banner_info_msg:
    'Only {{max}} banners can be active at a time, so this banner was saved as inactive.',
  sub_title: 'Sub Title',
  button_text: 'Button Text',
  button_action: 'Button Action',
  button_action_placeholder: 'e.g. /products',
  faq: 'FAQ',
  faqs: 'FAQs',
  add_faq: 'Add FAQ',
  edit_faq: 'Edit FAQ',
  faq_type: 'FAQ Type',
  question: 'Question',
  answer: 'Answer',
  enter_question: 'Enter Question',
  faq_page_description: 'Manage all your FAQs below.',
  why_great_photos_lead_to_better_offers: 'WHY GREAT PHOTOS LEAD TO BETTER TRADE-IN OFFERS',
  why_great_photos_lead_to_better_offers_desc_1:
    "Dealers expect used firearms to show wear, scratches, and holster marks. What prevents trade-in offers is uncertainty. If a dealer can't see an accurate representation of the firearm, they will not make an offer.",
  why_great_photos_lead_to_better_offers_desc_2:
    "If there are scratches, finish loss, rust spots, or anything else worth noticing, photograph it clearly. Honest photos and descriptions build trust, and trust moves deals forward. You are more likely to receive trade-in offers on a well-photographed gun that needs some work than on a gun that has no scratches but no proof. If your gun is in great shape, that's good too! Just be sure to send good photos to show off mint condition firearms.",
  taking_photos_for_trade_in_offers: 'TAKING PHOTOS FOR TRADE-IN OFFERS',
  taking_photos_for_trade_in_offers_subtitle: 'Tips for getting the best offers for your firearm',
  how_to_get_best_trade_in_offers: 'HOW TO GET THE BEST TRADE-IN OFFERS',
  key_to_great_offers_description:
    'No matter the condition of your firearm, the key to great offers is showing dealers exactly what they\nwould be getting.',
  handgun: 'Handgun',
  long_gun: 'Long-Gun',
  photo_count_of: 'Photo {{current}} of {{total}}',
  next: 'Next',
  left_side_view: 'LEFT SIDE VIEW',
  left_side_view_desc:
    'Capture the entire left side of the firearm to show its overall condition, configuration, and visible features.',
  action_chamber: 'ACTION / CHAMBER',
  action_chamber_desc: 'Provide a clear view of the action or chamber area.',
  stock_or_grip: 'STOCK OR GRIP',
  stock_or_grip_desc: 'Show the condition of the stock or grips.',
  markings: 'MARKINGS',
  markings_desc: 'Close-up photos of manufacturer markings, serial numbers, and proof marks.',
  additional_components: 'ADDITIONAL COMPONENTS',
  additional_components_desc: 'Any other important components of the firearm.',
  top_bottom_views: 'TOP AND BOTTOM VIEWS',
  top_bottom_views_desc: 'Provide views from above and below.',
  barrel_and_muzzle: 'BARREL AND MUZZLE',
  barrel_and_muzzle_desc: 'Clear view of the barrel and muzzle condition.',
  accessories: 'ACCESSORIES',
  accessories_desc: 'Include any accessories that will be traded in.',
  wear_or_damage: 'WEAR OR DAMAGE',
  wear_or_damage_desc: 'Highlight any specific wear, scratches, or damage.',
  left_right_side_photos_label: 'Left-side and right-side photos',
  action_chamber_photo_label: 'Action/chamber photo',
  stock_grip_photos_label: 'Stock or grip photos',
  close_ups_markings_label: 'Close-ups of markings',
  additional_component_photos_label: 'Additional component photos',
  top_bottom_views_label: 'Top and bottom views',
  barrel_muzzle_photo_label: 'Barrel and muzzle photo',
  accessories_photos_label: 'Accessories photos',
  photos_wear_damage_label: 'Photos of any wear or damage',
  full_photo_checklist: 'FULL PHOTO CHECKLIST',
  photo_tips: 'PHOTO TIPS',
  entire_firearm_visible: 'Entire firearm visible',
  natural_bright_lighting: 'Natural, bright lighting',
  flat_neutral_background: 'Flat, neutral background',
  in_focus_clear: 'In-focus & clear',
  price: 'Price',
  original_price: 'Original Price',
  discounted: 'Discounted',
  tax_summary: 'Tax Summary',
  dimentions: 'Dimensions',
  no_coupons_linked: 'No Coupons Linked',
  discounted_price: 'Discounted Price',
  product_detail: 'Product Details',
  barrel_length: 'Barrel Length',
  model: 'Model',
  product_model: 'Product Model',
  product_images: 'Product Images',
  product_details: 'Product Details',
  product_description: 'Product Description',
  condition: 'Condition',
  condition_short: 'Cond',
  gauge: 'Gauge',
  capacity: 'Capacity',
  finish: 'Finish',
  grips: 'Grips',
  what_include: "What's include",
  edit_product: 'Edit Product',
  edit_product_tagline: 'Update the product details below.',
  sub_category: 'Sub-Category',
  description: 'Description',
  images: 'Images',
  upc: 'UPC',
  sku: 'SKU',
  shipping: 'Shipping',
  in_stock: 'In Stock',
  payment_type: 'Payment Type',
  payment_type_card: 'Card',
  google_pay: 'Google Pay',
  apple_pay: 'Apple Pay',
  buy_with: 'Buy with',
  add_product: 'Add New Product',
  add_new_product: 'Add New Product',
  add_new_product_tagline: 'Fill out the product details below.',
  dashboard: 'Dashboard',
  all_users: 'All Users',
  all_products: 'All Products',
  products_drafts: 'Products Drafts',
  settings: 'Settings',
  list_products_drafts: 'List Products Drafts',
  item_number: 'Item Number',
  acquisition_type: 'Acquisition Type',
  type: 'Type',
  direct_shipping: 'Direct Shipping',
  ffl_shipping: 'Ship to FFL',
  select_acquisition_type: 'Select Acquisition Type',
  select_item_type: 'Select Item Type',
  select_ffl_name: 'Select FFL Name',
  edit_product_draft: 'Edit Product Draft',
  products_draft: 'Products Drafts',
  title: 'Title',
  list_view: 'List View',
  grid_view: 'Grid View',
  category_page_description: 'Manage all your category below.',
  blog_category_page_description: 'Manage all your blog categories below.',
  orders: 'Orders',
  track_shipments_and_ffl_transfers: 'Track shipments & FFL transfers',
  payment_details: 'Payment Details',
  total_sales: 'Total Sales',
  date_and_time: 'Date and Time',
  date_time: 'Date & Time',
  current_month_sales: 'Current Month Sales',
  order_details: 'Order Details',
  order_page_description: 'Manage all your orders below.',
  blogs: 'Blogs',
  suggested_blogs: 'Suggested Blogs',
  browse_all_departments: 'Browse All Departments',
  all_in: 'All in',
  blog_page_description: 'Manage all your blogs below.',
  blog_list: 'Blog List',
  add_blog: 'Add Blog',
  all_blogs: 'All Blogs',
  create_blog: 'Create Blog',
  blog_form_subtitle: 'Fill out the blog form below save and publish',
  blog_title_placeholder: 'Enter Blog Post Title...',
  blog_short_description_placeholder: 'Write a brief excerpt to hook your readers...',
  blog_body_placeholder:
    'Start writing your story here... Use the toolbar above or Markdown shortcuts for faster editing.',
  blog_publishing: 'Publishing',
  blog_words: 'Words: {{words}}',
  drag_drop_or_click: 'Drag & Drop or Click',
  seo_and_metadata: 'SEO + Metadata',
  meta_title_optimal_hint: 'Optimal: 50-60 characters',
  meta_description_optimal_hint: 'Optimal: 150-160 characters',
  keywords_type_and_enter: 'Type a keyword and press Enter',
  seo_preview_description_placeholder:
    'Enter a meta description to see how your blog post might appear in search engine results...',
  author: 'Author',
  schedule_the_post: 'Schedule the post',
  video_url: 'Video URL',
  short_description: 'Short Description',
  post_body: 'Post Body',
  featured_image: 'Featured Image',
  main_image: 'Main image',
  sms_templates: 'SMS Templates',
  sms_template: 'SMS Template',
  sms_template_page_description: 'Manage your sms templates',
  edit_sms_template: 'Edit SMS Template',
  email_templates: 'Email Templates',
  email_template: 'Email Template',
  email_template_page_description: 'Manage your email templates',
  edit_email_template: 'Edit Email Template',
  preview: 'Preview',
  subject: 'Subject',
  content: 'Content',
  content_page_type: 'Content Page Type',
  sub_header: 'Sub Header',
  content_page: 'Content Page',
  delete_content_page_confirm_text: 'delete content page',
  field: 'Field',
  template_content_tooltip:
    'Type your message below. You can insert fields to customize the message content.',
  copy_field_value: 'Copy Field Value',
  messages: 'Messages',
  message: 'Message',
  promo: 'Promo',
  message_details: 'Message Details',
  recipients: 'Recipients',
  read: 'Read',
  unread: 'Unread',
  reviews: 'Reviews',
  ffls: 'FFLs',
  reviews_page_description: "View all review given to FFL's",
  admin_reply: 'Admin Reply',
  share: 'Share',
  copy_link: 'Copy Link',
  link_copied_successfully: 'Link copied successfully',
  average_rating: 'Average Rating',
  total_reviews: 'Total Reviews',
  pending_reviews: 'Pending Reviews',
  approved_reviews: 'Approved Reviews',
  active_review: 'Active Review',
  inactive_review: 'Inactive Reviews',
  product_reviews: 'Product Reviews',
  product_reviews_page_description: "View all review given to Product's",
  read_more: 'Read More',
  read_less: 'Read Less',
  review: 'Review',
  verified_purchase: 'Verified Purchase',
  product_review: 'Product Review',
  rating: 'Rating',
  no_star: '{{key}} Star',
  to: 'To',
  selected_ffl: "Selected FFL's",
  approved_ffl: "Approved FFL's",
  pending_ffl: "Unapproved FFL's",
  rejected_ffl: "Rejected FFL's",
  declined: 'Declined',
  send_message: 'Send Message',
  send_message_page_description: 'View all your previous messages below.',
  blog_image_helping_text: 'Required image resolution 800x400, image size 10MB',
  try_another_category_blog_available:
    'Try another category once more published blogs are available.',
  newsletter_subscribed_successfully: 'You have subscribed to the newsletter successfully.',
  subscribe: 'Subscribe',
  please_wait: 'Please wait...',
  edit_blog: 'Edit Blog',
  blog_detail: 'Blog Detail',
  blog_categories_list: 'Blog Categories List',
  blog_categories: 'Blog Categories',
  admin_ffl_upload_main_image: 'Upload main image (Recommended image at least 600x200 px)',
  approve_ffl_confirm_text: 'approve ffl',
  decline_ffl_confirm_text: 'unapprove ffl',
  advertisements: 'Advertisements',
  advertisement_list: 'Advertisement List',
  add_advertisement: 'Add Advertisement',
  edit_advertisement: 'Edit Advertisement',
  advertisement_detail: 'Advertisement Detail',
  url: 'URL',
  clicks: 'Clicks',
  view: 'View',
  view_key: 'View {{key}}',
  enter_url: 'Enter URL',
  laptop_screen_image: 'Laptop screen image',
  tablet_screen_image: 'Tablet screen image',
  mobile_screen_image: 'Mobile screen image',
  fast_bound_information: 'Fast Bound Information',
  subscription_plan: 'Subscription Plan',
  subscription_plan_page_description: 'Manage your subscription plans',
  edit_subscription_plan: 'Edit Subscription Plan',
  add_subscription_plan: 'Add Subscription Plan',
  subscription_plan_edit_page_description:
    'Fill out the subscription plan form below save and publish',
  trial_days: 'Trial Days',
  plan_information: 'Plan Information',
  features: 'Features',
  price_information: 'Price Information',
  total_price: 'Total Price',
  blog_category: 'Blog category',
  blog: 'Blog',
  delete_blog_confirm_text: 'Delete blog',
  update_blog_status: 'Update blog status',
  draft: 'Draft',
  publish: 'Publish',
  archived: 'Archived',
  body: 'Body',
  product_attributes: 'Product Attributes',
  attributes: 'Attributes',
  product_attributes_page_discription: 'Manage Product Attributes',
  product_attribute_list: 'Product Attributes List',
  add_product_attribute: 'Add Product Attribute',
  option: 'Option',
  is_required: 'Required',
  text_value: 'text',
  number_value: 'number',
  boolean_value: 'boolean',
  select_value: 'select',
  multi_select_value: 'multi_select',
  text_label: 'Text',
  number_label: 'Number',
  boolean_label: 'Boolean',
  multi_select_label: 'Multi Select',
  option_value: 'Option Value',
  required: 'Required',
  allow_filter_on_product_listing_page: 'Allow Filter on product listing page',
  product_attribute: 'Product Attribute',
  add_new_blog: 'Add new blog',
  add_new_attribute: 'Add new attribute',
  edit_product_attribute: 'Edit Product Attribute',
  unpublish: 'Unpublish',
  add_new_advertisement: 'Add new advertisement',
  delete_advertisement_confirm_text: 'delete advertisement',
  product_attribute_section: 'Product Attribute Section',
  attribute: 'Attribute',
  dynamic_attributes: 'Dynamic Attributes',
  fixed_attributes: 'Fixed Attributes',
  content_pages: 'Content Pages',
  content_page_list: 'Content Page List',
  add_content_page: 'Add Content Page',
  edit_content_page: 'Edit Content Page',
  content_page_detail: 'Content Page Detail',
  advertisement: 'Advertisement',
  advertisement_status: 'Advertisement Status',
  all_advertisements: 'All Advertisements',
  location: 'Location',
  advertisement_location: 'Advertisement Location',
  page: 'Page',
  update_page_advertisement: 'Update page advertisement',
  sidebar_order: 'Sidebar Menu Order',
  sidebar_order_subtitle: 'Drag items within each section to customise the sidebar sequence.',
  custom_order_active: 'Custom Order Active',
  menu_items: 'Menu Items',
  drag_to_reorder: 'Drag rows within each section to reorder',
  sub: 'sub',
  items: 'Items',
  saved: 'Saved Successfully',
  save_order: 'Save Order',
  reset_to_default: 'Reset to Default',
  menu_order_saved_successfully: 'Menu order saved successfully',
  failed_to_save_menu_order: 'Failed to save menu order',
  delete_advertisement_location_confirm_text: 'delete advertisement location',
  guns_for_sale: 'Guns For Sale',
  views: 'Views',
  seller: 'Seller',
  download_pdf: 'Download PDF',
  download: 'Download',
  purchase_form_pdf: 'Purchase Form PDF',
  ship_from_ffl: 'Ship From (FFL)',
  ships_to_ffl: 'Ships to FFL',
  ships_to_home_address: 'Ships to Home Address',
  home_address: 'Home Address',
  shipping_to_transferee: 'Shipping To / Transferee',
  ship_to_transferee: 'Ship To / Transferee',
  ship_to_customer: 'Ship To (Customer)',
  grand_total: 'Grand Total',
  order_items: 'Order Items',
  order: 'Order',
  UPC: 'UPC',
  denied_transfer_message:
    'has denied this transfer. Also, a notification has been sent to the customer.',
  print_new_label: 'Print New Label',
  more_actions: 'More Actions',
  more_details: 'More Details',
  track_package: 'Track Package',
  shipment_status: 'Shipment Status',
  payment_status: 'Payment Status',
  placed_on: 'Placed on',
  ship_on: 'Ship on',
  expected: 'Expected',
  customer_info: 'Customer Info',
  item_timeline: 'Item Timeline',
  view_photos: 'View Photos',
  mark_as_paid: 'Mark as Paid',
  mark_as_ready_to_shipment: 'Mark as Ready to Shipment',
  mark_as_ready_to_ship: 'Mark as Ready to Ship',
  mark_as_ready_to_pickup: 'Mark as Ready to Pickup',
  mark_as_shipped: 'Mark as Shipped',
  mark_as_read: 'Mark as read',
  mark_not_shipped: 'Mark not shipped',
  mark_completed: 'Mark Completed',
  mark_not_completed: 'Mark Not Completed',
  mark_arrival_to_ffl: 'Mark Delivered to FFL',
  mark_not_arrived_to_ffl: 'Mark Not Delivered to FFL',
  ready_for_pickup: 'Ready for Pickup',
  mark_as_ready_for_pickup: 'Mark as Ready for Pickup',
  ready_for_ffl_pickup: 'Ready for Delivery',
  add_tracking_number_update_shipping: 'Add Tracking Number / Update Shipping',
  add_tracking_number: 'Add Tracking Number',
  no_order_items_found: 'No order items found',
  no_tracking_changes_to_save: 'No tracking number changes to save',
  view_payment_details: 'View Payment Details',
  transaction_detail: 'Transaction Detail',
  transaction_summary: 'Transaction Summary',
  carrier_name: 'Carrier Name',
  tracking_url: 'Tracking URL',
  track_shipment: 'Track Shipment',
  approve_and_mark_ready_to_ship: 'Mark as Ready to Ship',
  manual_shipment_approval_note:
    "No shipping carrier and service is configured for this item, so a label can't be booked. Ship it yourself and enter its tracking details - approving moves it to Ready to Ship and notifies the customer.",
  print_label_payment_pending: 'Payment is pending, so shipment details are not available yet.',
  print_label_payment_failed: 'Payment has failed, so shipment details are not available.',
  print_shipping_label: 'Print Shipping Label',
  ready_to_ship: 'Ready to Ship',
  print_label_approve_transfer_confirm:
    'Printing a shipping label will book the shipment to the current receiving FFL address and approve the pending transfer request. Do you want to continue?',
  ready_to_ship_approve_transfer_confirm:
    'Marking this order Ready to Ship will book the shipment to the current receiving FFL address and approve the pending transfer request. Do you want to continue?',
  print_label_no_shipment: 'Shipment details are not available yet for this order.',
  manual_shipment_no_label: 'This shipment is handled manually, so no shipping label is available.',
  transaction_information: 'Transaction Information',
  transaction_reference: 'Transaction Reference',
  transaction_date: 'Transaction Date',
  card_last_four: 'Card (last 4)',
  order_information: 'Order Information',
  customer_information: 'Customer Information',
  recorded_by: 'Recorded By',
  gateway_response: 'Gateway Response',
  no_transaction_found: 'No transaction found',
  no_records_found: 'No records found',
  total_items: 'Total Items',
  add_note: 'Add note',
  edit_note: 'Edit note',
  give_buyer_feedback: 'Give buyer feedback',
  report_buyer: 'Report buyer',
  report_buyer_email_subject: 'Report buyer - Order #{{order_number}}',
  report_buyer_email_body:
    'Order number: {{order_number}}\nBuyer name: {{buyer_name}}\nBuyer email: {{buyer_email}}\n\nReason for reporting this buyer:\n',
  support_email_not_configured: 'Support email is not configured in settings',
  relist: 'Relist',
  sell_similar: 'Sell Similar',
  download_order_data: 'Download Order Data',
  cancel_order_with_reason: 'Cancel Order (with reason)',
  cancel_order: 'Cancel Order',
  cancellation_reason: 'Cancellation Reason',
  additional_note: 'Additional Note',
  cancel_order_warning:
    'This cancels the order and every item on it, rejects its open transfer requests, and cannot be undone.',
  reason_buyer_asked_to_cancel: 'Buyer asked to cancel',
  reason_out_of_stock: 'Item out of stock',
  reason_problem_with_buyer_address: "Problem with buyer's address",
  reason_duplicate_order: 'Duplicate order',
  reason_other: 'Other',
  order_cancelled_successfully: 'Order cancelled successfully',
  // order detail export column labels
  customer_mobile: 'Customer Mobile',
  listed_unit_price: 'Listed Unit Price',
  offer_price: 'Offer Price',
  offer_discount: 'Offer Discount',
  item_subtotal: 'Item Subtotal',
  item_discount: 'Item Discount',
  item_shipping: 'Item Shipping',
  item_tax: 'Item Tax',
  item_total: 'Item Total',
  delivery_type: 'Delivery Type',
  tracking_number: 'Tracking Number',
  shipping_service: 'Shipping Service',
  order_subtotal: 'Order Subtotal',
  order_discount: 'Order Discount',
  order_offer_discount: 'Order Offer Discount',
  order_shipping: 'Order Shipping',
  order_tax: 'Order Tax',
  currency: 'Currency',
  notes: 'Notes',
  print_order_summary: 'Print Order Summary',
  allow_popups_to_print: 'Please allow popups for this site to print the order summary',
  amount_due: 'Amount Due',
  purchased_method: 'Purchased Method',
  purchase_method: 'Purchase Method',
  purchased_form: 'Purchased Form',
  payment_summary: 'Payment Summary',
  download_form: 'Download Form',
  payment_instructions: 'Payment Instructions',
  method: 'Method',
  reference: 'Reference',
  read_the_cover_story: 'Read the cover story',
  min_read: 'Min. Read',
  buyer_note: 'Buyer Note',
  billing_address: 'Billing Address',
  shipping_address: 'Shipping Address',
  pdf_preview: 'Pdf preview',
  product_listing: 'Product Listing',
  seller_information: 'Seller Information',
  address: 'Address',
  default_address: 'Default Address',
  working_condition: 'Working Condition',
  original_packaging: 'Original packaging',
  seller_signature: 'Seller Signature',
  id: 'ID',
  created: 'Created',
  no_select: 'No selection',
  gun_for_sale_description: 'View all guns for sale below.',
  listed_products: 'listed products',
  sold_products: 'sold',
  product_sold: 'Product Sold',
  sold: 'Sold',
  units: 'Unit(s)',
  sold_on: 'Sold On',
  ffl_buyer: 'FFL Buyer',
  mark_sold: 'Mark sold',
  mark_sold_confirm_text: 'mark it sold',
  purchase_forms: 'Purchase Forms',
  purchase_forms_page_description: 'Manage your purchase forms below.',
  seller_ffl: 'Seller FFL',
  dates: 'Dates',
  'order_#': 'Order #',
  'item_#': 'Item #',
  order_id: 'Order ID#',
  orderId: 'Order ID',
  from_ffl: 'From FFL',
  to_ffl: 'To FFL',
  payment: 'Payment',
  payment_failed: 'Payment Failed',
  shipping_to: 'Shipping To',
  colon_all: '{{key}}: All',
  seller_detail: 'Seller Detail',
  shipping_detail: 'Shipping Detail',
  buyer_detail: 'Buyer Detail',
  view_store: 'View Store',
  purchase_form: 'Purchase Form',
  booking_id: 'Booking ID',
  affiliate_code: 'Affiliate Code',
  referral_code: 'Referral Code',
  assigned_user: 'Assigned User',
  assigned_ffl_email: 'Assigned FFL Email',
  affiliate_codes: 'Affiliate Codes',
  affiliate_code_page_description: 'Manage all your affiliate codes below.',
  avg_referral_revenue: 'Ave. Referral Revenue',
  total_referral_revenue: 'Total Referral Revenue',
  return_on_investment: 'Return On Investment',
  referral_codes_used: 'Referral Codes Used',
  total_codes_created: 'Total Codes Created',
  total_usage_count: 'Total Usage Count',
  total_discount_given: 'Total Discount Given',
  total_order_amount: 'Total Order Amount',
  unique_referred_accounts: 'Unique Referred Accounts',
  search: 'Search...',
  create_affiliate_code: 'Create Affiliate Code',
  edit_affiliate_code: 'Edit Affiliate Code',
  referrer_percentage: 'Referrer Percentage(%)',
  referred_discount: 'Referred Discount(%)',
  assigned_ffl: 'Assign FFL',
  create_new: 'Create New',
  delete_affiliate_code_confirm_text: 'affiliate code',
  invalid_email: 'Please enter a valid email address.',
  referred_accounts: 'Referred Accounts',
  referred_by: 'Referred By',
  total_amount_owed: 'Total Amount Owed',
  referral_revenue: 'Referral Revenue',
  view_more: 'View More',
  more_images_count: '{{count}} more images',
  view_sub_orders: 'View {{count}} sub-orders',
  hide_sub_orders: 'Hide sub-orders',
  affiliateAnalysis: 'Analytics',
  affiliateList: 'List',
  active_coupons: 'Active Coupons',
  expired_coupons: 'Expired Coupons',
  exhausted_coupons: 'Exhausted Coupons',
  total_redemptions: 'Total Redemptions',
  coupon_codes: 'Coupon codes',
  coupon_page_description: 'Manage all your coupons below.',
  coupon_code: 'Coupon code',
  label: 'Label',
  start_date: 'Start date',
  end_date: 'End date',
  discount_value: 'Discount',
  max_discount_amount: 'Max Discount',
  min_order_amount: 'Min Order Value',
  times_used: 'Times Used',
  usage_limit: 'Usage Limit',
  usage_per_user: 'Usage per user',
  delete_coupon_confirm_text: 'delete coupon',
  coupon_basic_section: 'Basic',
  code: 'Code',
  coupon_discount_section: 'Discount',
  coupon_applicability_section: 'Applicability',
  applicable_to: 'Applicable to',
  coupon_usage_section: 'Usage',
  coupon_validity_section: 'Validity',
  validity_period: 'Validity period',
  discount_type: 'Discount type',
  percentage: 'Percentage',
  flat: 'Flat',
  add_coupon: 'add coupon',
  edit_coupon: 'edit coupon',
  coupon_edit_page_description: 'Fill out the coupon form below save and publish',
  advertisement_description: 'Manage all your advertisements below.',
  advertisement_url: 'Advertisement URL',
  update_advertisement_status: 'Update advertisement status',
  vertical_screen_image: 'Vertical screen image ',
  advertisement_edit_page_description: 'Fill out the advertisement form below save and publish',
  orientation: 'Orientation',
  date_added: 'Date added',
  advertisement_details: 'Advertisement details',
  total_ffls: "FFL'S",
  total_products: 'PRODUCTS',
  total_customers: 'CUSTOMERS',
  total_guns: 'GUNS FOR SALE',
  import_products: 'Import Products',
  csv_file: 'Csv File',
  drag_drop_csv: 'Click or drag file here',
  or_click_to_browse: 'Support only',
  import_complete: 'Import Report',
  subject_line: 'Subject Line',
  select_ffl: 'Select FFL',
  product_import_ffl_note: 'Every product in the file is listed under this FFL.',
  attach_image: 'Attach Image',
  attach_images: 'Add attachment(s)',
  attach_images_plural: 'Attach Image(s)',
  customer_page_description: 'Manage all your customers below.',
  customer_group_page_description: 'Manage all your customer groups below.',
  no_rejected: 'No records were rejected.',
  setting_page_description: 'Manage all general setting below.',
  general: 'General',
  settings_key: 'Identifier key',
  settings_value: 'Value',
  general_setting: 'General Setting',
  add_new_general_setting: 'Add New General Setting',
  edit_general_setting: 'Edit General Setting',
  google_business_account: 'Google Business Account',
  ffl_edit_page_description: 'Manage all your FFL’s below.',
  other: 'Other',
  nfa: 'NFA',
  yellow_page: 'Yellow Pages',
  yelp: 'Yelp',
  trustpilot: 'Trustpilot',
  address_information: 'ADDRESS INFORMATION',
  add_address: 'Add Address',
  edit_address: 'Edit Address',
  hours_of_operation: 'HOURS OF OPERATION',
  not_available: 'Not available',
  copy_to_all: 'Copy to all',
  store_descriptions: 'Store Description',
  social_media_links: 'SOCIAL MEDIA LINKS',
  banner_images: 'BANNER IMAGES',
  transfer_fees: 'TRANSFER FEES',
  numbers_only: '(Numbers Only)',
  store_details: 'STORE DETAILS',
  user_details: 'USER DETAILS',
  change_image: 'Change Image',
  remove_image: 'Remove Image',
  payment_gateway: 'Payment Gateway',
  api_credentials: 'API Credentials',
  long_gun_fee: 'Long gun fee',
  handgun_fee: 'Handgun fee',
  nfa_fee: 'NFA fee',
  other_fee: 'Other fee',
  ffl_details: 'FFL Details',
  contact: 'Contact',
  how_to_buy: 'How to Buy',
  how_to_sell: 'How to Sell',
  partners: 'Partners',
  support: 'Support',
  company: 'Company',
  shop: 'Shop',
  join_the_network: 'Join the Network',
  featured_all: 'Featured: All',
  selected_customer: 'Selected Customer',
  select_customer: 'Select Customer',
  selected_customer_group: 'Customer Group',
  notifications: 'Notifications',
  notification_from_mlgs: 'Notification from MLGS',
  no_notifications: 'No notifications',
  no_unread_notifications: 'No unread notifications',
  mark_all_as_read: 'Mark all as read',
  load_more: 'Load more',
  transfer_request: 'Transfer Request',
  transfer_request_complited: 'Transfer Request Complited',
  transfer_request_page_description: 'Manage all you transfer request below.',
  order_no_all: 'Order #: All',
  sending_receiving: 'Sending / Receiving',
  ffls_all: 'FFLs: All',
  transactions: 'Transactions',
  transaction: 'Transaction',
  transaction_page_description: 'Manage all your transactions below.',
  type_all: 'Type: All',
  payment_gateway_all: 'Payment Gateway: All',
  payment_status_all: 'Payment Status: All',
  user_name: 'User Name',
  user_email: 'User Email',
  cod: 'COD',
  authorize_net: 'Authorized.Net',
  mx_merchant: 'MX Merchant',
  view_detail: 'View Detail',
  ffl_from: 'FFL from',
  ffl_to: 'FFL to',
  shipped: 'Shipped',
  ready_to_shipment: 'Ready to Shipment',
  contains_ffl_orders: 'Contains: {{ total }} FFL Orders',
  group_order_tooltip:
    'This represents the parent group order, consolidating item purchases. Sub-orders are grouped and processed by their respective FFL(s).',
  no_photos_available: 'No Photos Available',
  in_progress: 'In Progress',
  completed: 'Completed',
  dealer_type: 'Dealer Type',
  ffl_license_types: 'FFL License Types',
  license_type_no_description: 'No description available for this license type.',
  drag_pin_to_change_location: 'Drag to change your search location',
  type_01: 'Type 01 - Dealer in Firearms Other Than Destructive Devices',
  type_02: 'Type 02 - Pawnbroker in Firearms Other Than Destructive Devices',
  type_03: 'Type 03 - Collector of Curios and Relics',
  type_06:
    'Type 06 - Manufacturer of Ammunition for Firearms Other Than Ammunition for Destructive Devices or Armor Piercing Ammunition',
  type_07: 'Type 07 - Manufacturer of Firearms Other Than Destructive Devices',
  type_08:
    'Type 08 - Importer of Firearms Other Than Destructive Devices or Ammunition for Firearms Other Than Destructive Devices, or Ammunition Other Than Armor Piercing Ammunition',
  type_09: 'Type 09 - Dealer in Destructive Devices',
  type_10:
    'Type 10 - Manufacturer of Destructive Devices, Ammunition for Destructive Devices or Armor Piercing Ammunition',
  type_11:
    'Type 11 - Importer of Destructive Devices, Ammunition for Destructive Devices or Armor Piercing Ammunition',
  ffl_license: 'FFL License',
  upload_ffl_license: 'Upload FFL License',
  replace_ffl_license: 'Replace FFL License',
  no_results_found: 'No results found',
  gunsmith: 'Gunsmith',
  indoor_range: 'Indoor Range',
  outdoor_range: 'Outdoor Range',
  gun_club: 'Gun Club',
  retailer: 'Retailer / Gun Store',
  pawn_shop: 'Pawn Shop',
  distributor: 'Distributor / Wholesaler',
  law_enforcement_supply: 'Law Enforcement Supply',
  training_facility: 'Training Facility',
  online_retailer: 'Online Retailer',
  collector: 'Collector / Auction House',
  review_ffl_detail: 'Review FFL Details',
  is_featured: 'Featured',
  contact_number: 'Contact Number',
  alert: 'Alert',
  complete_profile_message: 'Complete your profile to get the most out of MLGS.',
  update_profile: 'Update Profile',
  create_an_account: 'Create an account',
  new_here_choose_signup: 'New here? Choose how you’d like to sign up',
  ffl_sign_up: 'FFL Sign-Up',
  for_individual_buyers: 'For Individual Buyers',
  for_federal_firearm_licensees: 'for federal firearm licensees',
  didnt_receive_it: "Didn't receive it? Check your spam folder or try again in a few minutes.",
  mark_sold_successfull_message: '{{key}} mark as sold Successfully',
  gun: 'Gun',
  published: 'Published',
  author_all: 'Author: All',
  blog_publish: 'Published',
  list_blogs: 'List Blogs',
  archive_blogs: 'Archive Blogs',
  delete_blogs: 'Delete Blogs',
  deleted_selected_successfull_message: 'Selected {{key}}s Deleted Successfully',
  delete_selected_confirm_title: 'DELETE SELECTED {{key}}s?',
  delete_selected_confirm_msg: 'Are you sure, once you delete you can’t recover these {{key}}s.',
  list_selected_confirm_title: 'LIST SELECTED {{key}}s?',
  list_selected_confirm_msg: 'Are you sure you want to list all these {{key}}s?',
  list_selected_successfull_message: 'Selected {{key}}s Listed Successfully',
  archive_selected_confirm_title: 'ARCHIVE SELECTED {{key}}s?',
  archive_selected_confirm_msg: 'Are you sure you want to archive all these {{key}}s?',
  archive_selected_successfull_message: 'Selected {{key}}s Archived Successfully',
  employee_name: 'Employee name',
  create_new_message: 'Create New Message',
  send_to: 'Sent To',
  date_sent: 'Date sent',
  published_date: 'Published Date',
  general_settings: 'General Settings',
  last_login: 'last login',
  basic_information: 'Basic information',
  ffl_number: 'FFL Number',
  owner_representative: 'Owner / Representative',
  contact_email: 'Contact Email',
  personal_phone_number: 'Personal Phone Number',
  business_number: 'Business Number',
  ffl_license_document: 'FFL License Document',
  primary_business_address: 'Primary Business Address',
  allow_return_refund: 'Allow Purchased Product Returns & Refunds?',
  allow_multiple_coupon_codes: 'Allow Multiple Coupon Codes?',
  returns_refunds_accepted: 'Returns & Refunds Accepted',
  returns_not_accepted: 'Returns not accepted',
  mailing_address: 'Mailing Address',
  license_name: 'License Name',
  not_registered: 'Not Registered',
  registered: 'Registered',
  // a declined transfer request sent to another FFL
  send_to_another_ffl: 'Send to another FFL',
  choose_another_ffl: 'Choose another FFL',
  select_new_ffl: 'Select New FFL',
  search_by_ffl_name: 'Search by FFL name',
  transfer_ffl_zip_hint:
    "Showing FFLs nearest to {{zip}} (the customer's ZIP code). Change or clear it to search elsewhere.",
  transfer_ffl_no_zip_hint: 'Enter a ZIP code to see the FFLs nearest to it.',
  send_transfer_request: 'Send Transfer Request',
  send_transfer_request_confirm: 'Send a new transfer request to {{name}}?',
  transfer_request_sent_to_ffl: 'Transfer request sent to the new FFL.',
  activity_sales: 'Activity Sales',
  products_listed: 'Products listed',
  total_sold: 'Total Sold',
  total_sales_revenue: 'Total sales/revenue',
  speciality_services: 'Speciality services',
  member_since: 'Member since',
  license: 'License',
  subscription_type: 'Subscription type',
  payment_card: 'Payment card',
  card_expiration: 'Card expiration',
  operating_hours: 'Operating hours',
  nfa_class_3: 'nfa class 3',
  view_ffl_licence: 'VIEW FFL LICENSE',
  ffl_info: 'FFL Info',
  revenue: 'Revenue',
  membership: 'Membership',
  activity: 'Activity',
  add_subcategory: 'Add Sub-Category',
  edit_subcategory: 'Edit Sub-Category',
  processing: 'Processing',
  cancelled: 'Cancelled',
  failed: 'Failed',
  confirmed: 'Confirmed',
  purchased: 'Purchased',
  customer_name: 'Customer Name',
  customer_email: 'Customer Email',
  order_number: 'Order Number',
  order_status: 'Order Status',
  date: 'Date',
  product_name: 'Product Name',
  product_type: 'Product Type',
  quantity: 'Quantity',
  discount: 'Discount',
  order_item_status: 'Order Item Status',
  shipping_ffl: 'Shipping FFL',
  shipping_ffl_number: 'Shipping FFL Number',
  shipping_ffl_address: 'Shipping FFL Address',
  store: ' Store',
  delete_ffl: 'delete ffl',
  action_cannot_be_undone: 'This action cannot be undone!',
  delete_ffl_permanent_msg:
    'Deleting this ffl will permanently remove all associated data from the system.',
  items_sold: 'Items sold',
  pending_orders_affected: 'pending orders will be affected.',
  pending_transfers_affected: 'pending transfers will be affected.',
  permanently_deleted_label: 'The following will be permanently deleted:',
  ffl_account_profile_info: 'FFL account and profile information',
  sales_history_transaction_records: 'Sales history and transaction records',
  customer_reviews_ratings: 'Customer reviews and ratings',
  communication_history: 'Communication history',
  number_of_employees: 'Number of Employees',
  number_of_blogs: 'Number of Blogs',
  delete_blog: 'Delete Blog',
  delete_blog_permanent_msg:
    'Proceeding will permanently delete all data associated with this entry.',
  post: 'Post',
  analytics: 'Analytics',
  total_clicks: 'total clicks',
  ads: 'Ads',
  associated_analytics_history_will_be_permanently_removed:
    'Associated analytics history will be permanently removed.',
  post_will_be_removed_from_all_assigned_categories:
    'Post will be removed from all assigned categories.',
  seo_indexing_for_this_specific_url_will_be_disabled:
    'SEO indexing for this specific URL will be disabled.',
  associated_ads_on_this_article_will_be_removed: 'Associated Ads on this article will be removed.',
  post_content_and_media_mappings: 'Post content and media mappings.',
  seo_and_meta_configuration: 'SEO and meta configuration.',
  view_count_and_performance_analytics: 'View count and performance analytics.',
  active_ads_combined_views_clicks:
    '{{ads}} active ads (combined {{views}} views & {{clicks}} clicks)',
  total_views: 'Total Views',
  featured_blog_placement_will_be_removed: 'Featured blog placement will be removed.',
  delete_blog_category: 'Delete Blog Category',
  delete_category_permanent_message:
    'Deleting this category will permanently remove all associated data and move published posts in this category to draft. System integrity requires explicit confirmation.',
  published_posts_will_be_moved_to_draft: '{{post}} published posts will be moved to ‘Draft’',
  draft_posts_will_be_marked_for_review:
    '{{draft}} drafts will be affected and marked for taxonomy review.',
  seo_keywords_will_be_removed:
    'Associated SEO keywords for this category will be removed from system indexing.',
  taxonomy_mappings_removed: 'Related taxonomy mappings',
  analytics_history_deleted_views: 'Category analytics history ({{views}} total views)',
  analytics_total_views: 'Analytics ({{views}} total views)',
  confirm_delete_text_mismatch: 'Text does not match. Please type "{{ key }}".',
  confirm_delete_helping_text: 'TO CONFIRM DELETION, TYPE "{{ key }}" IN THE FIELD BELOW:',
  confirm_delete_placeholder: 'Type "Delete {{ key }}" here',
  posts: 'posts',
  connect_shipping_provider: 'Connect Shipping Provider',
  carrier_auth_required: 'Carrier authentication require the validation',
  api_key: 'API Key',
  api_secret: 'API Secret',
  confirm_delete_mismatch: 'Confirm delete mismatch',
  yes_list: 'Yes, List',
  yes_unlist: 'Yes, Unlist',
  please_fill_required_address_fields: 'Please fill required address fields',
  product_title: 'Product Title',
  free: 'Free',
  actual: 'Actual',
  flat_rate: 'Flat Rate',
  listed: 'Listed:',
  sold_status: 'Sold:',
  manuf: 'Manuf.',
  product_qty: 'QTY.',
  barrel_twist: 'Barrel Twist',
  overall_length: 'Overall Length',
  safety: 'Safety',
  country_of_origin: 'Country of Origin',
  intended_use: 'Intended Use',
  suppressor_ready: 'Suppressor Ready',
  california_legal: 'California Legal',
  cr_eligible: 'C&R Eligible (Curio & Relic)',
  asking_price: 'Asking Price',
  quantity_in_stock: 'Quantity in Stock',
  quantity_synced_with_options: 'Calculated from the total quantity of all options.',
  auto_accept_offers: 'Auto accept offers',
  auto_accept_offers_above: 'Auto-Accept Offers Above',
  tax_percent: 'Tax %',
  tax_value: 'Tax Value',
  sku_stock_keeping_unit: 'SKU (Stock Keeping Unit)',
  barcode_isbn_upc_gtin: 'Barcode (ISBN, UPC, GTIN)',
  barcode: 'Barcode',
  auto_accept_price: 'Auto accept price',
  exclusive: 'Exclusive',
  inclusive: 'Inclusive',
  inclusive_tax: 'Inclusive Tax',
  exclusive_tax: 'Exclusive Tax',
  tax_type: 'Tax type',
  serial_number: 'Serial Number',
  technical_specifications: 'Technical specifications',
  free_shipping: 'Free Shipping',
  shipping_method: 'Shipping Method',
  shipping_fee: 'Shipping fee',
  length_in: 'length (in)',
  width_in: 'Width (in)',
  height_in: 'Height (in)',
  weight_lb: 'Weight (lbs)',
  lbs: 'lbs',
  shipping_service_provider: 'Shipping service provider',
  days: 'Day(s)',
  handling_time: 'Handling Time',
  est_shipping_cost: 'EST. Shipping Cost $10.00-$17.65',
  business_day: 'Business day',
  shipping_provider: 'Shipping provider',
  product_status: 'Product status',
  promotion_coupon_codes: 'PROMOTION + COUPONS codes',
  link_existing_coupons: 'Link Existing Coupons',
  serial_number_recorded: 'Serial number recorded',
  category_caliber_set: 'Category & caliber set',
  seller_certification_unchecked: 'Seller certification — {{ count }} unchecked',
  seller_certification: 'Seller certification',
  shipping_restrictions_set: 'Shipping restrictions set',
  price_entered: 'Price entered',
  min_4_photos_recommended: 'Min. 4 photos recommended',
  seo_optimized_title: 'SEO optimized title...',
  tactical_precision_rifle: 'tactical, precision, rifle...',
  search_engine_snippet: 'Search engine snippet...',
  search_engine_listing_preview: 'Search engine listing preview',
  backlink_url: 'Backlink URL',
  product_url: 'Product URL',
  listing_type: 'Listing Type',
  organization: 'Organization',
  product_organization_tooltip:
    'Specify the organization or dealer name responsible for this product listing.',
  product_ffl_tooltip:
    'The approved FFL this product is listed under. It is chosen when the product is created and cannot be changed afterwards.',
  product_ffl_locked_note: 'The FFL cannot be changed after the product is created.',
  product_ffl_change_note:
    'Changing the FFL clears the shipping methods, coupons and linked variations chosen below.',
  external_canonical_url: 'External canonical URL',
  product_visibility: 'Product Visibility',
  availability: 'Availability',
  sales_channels: 'Sales channels',
  drop_shipped: 'Drop-Shipped',
  in_store: 'In-Store',
  online: 'Online',
  local_pick_up: 'Local Pick-Up',
  shipping_rates_helping_text: 'Used to calculate shipping rates (in inches) ',
  tax_helping_text: 'Tax will be calculated on the discounted price or accepted price.',
  handling_time_helping_text:
    'This signals to customers how quickly their items will be dispatched after purchase.',
  select_service: 'select the service',
  business_days: 'Business Days',
  priority_mail: 'Priority Mail',
  select_service_1: '2 - 5 business days',
  select_service_2: 'Tracking included: Yes',
  select_service_3: 'Max. 22 lb',
  select_service_4: '$80.00 - $110.65',
  add_images: 'Add Images',
  add_more: 'Add More',
  last_saved: 'Last saved',
  product_variations: 'Product Variations',
  add_variations: 'Add Variations',
  save_as_draft: 'Save as Draft',
  preview_and_publish: 'Preview & Publish',
  add_new_product_description:
    "Describe your item, and we'll start your listing based on items in our catalog.",
  search_product_placeholder: 'Search by brand, model, serial number, product name',
  searching: 'Searching...',
  no_products_found: 'No products found',
  suggestions_found: '{{count}} SUGGESTIONS FOUND',
  suggestion_found: '{{count}} SUGGESTION FOUND',
  feature_coming_soon: '{{feature}} is coming soon.',
  importing_from_a_product_link: 'Importing from a product link',
  start_your_listing_with_a_link: 'Start your listing with a link',
  start_listing_with_item_info: 'Start listing with item info',
  list_similar: 'List Similar',
  upload_manually: 'Upload Manually',
  upload_manually_desc: 'Enter item details one by one to create a custom listing.',
  bulk_listing: 'Bulk listing',
  bulk_listing_desc: 'Import a CSV or XLSX file with info about your inventory.',
  sync_via_integrations: 'Sync via Integrations',
  sync_via_integrations_desc:
    'Skip manual entry by connecting your POS, Bound Book, or existing platform.',
  continue_where_you_left_off: 'CONTINUE WHERE YOU LEFT OFF',
  view_all_drafts: 'View All Drafts',
  continue_editing: 'Continue Editing',
  bulk_listing_title: 'BULK LISTING',
  import_csv_description: 'Import a CSV file with info about your inventory.',
  close: 'Close',
  importing: 'IMPORTING',
  import_completed: 'Import Complete',
  downloading: 'DOWNLOADING...',
  download_sample_file: 'DOWNLOAD SAMPLE FILE',
  successful: 'SUCCESSFUL',
  remaining: 'REMAINING',
  create_new_coupon: 'create new coupon',
  product_live_preview: 'PRODUCT LIVE PREVIEW',
  product_preview: 'PRODUCT PREVIEW',
  preview_subtitle: 'Checkout the product details below.',
  product_published_title: 'PRODUCT PUBLISHED!',
  product_published_subtitle:
    'Your product has been successfully added to your store and is now visible to customers.',
  live_on_catalog: 'LIVE ON CATALOG',
  payment_gateway_not_connected: 'Payment Gateway Not Connected',
  payment_gateway_warning_text:
    "Your customers won't be able to purchase this item until a payment gateway is integrated.",
  connect_payment_gateway: 'Connect Payment Gateway',
  view_product_in_store: 'View Product in Store',
  add_another_product: 'Add Another Product',
  return_to_dashboard: 'Return to Dashboard',
  publishing: 'Publishing...',
  listing_quality: 'LISTING QUALITY',
  active_listing_and_bids: 'Active listings & bids',
  offers: 'Offers',
  accepts_offers: 'Accepts Offers',
  no_offers: 'No Offers',
  instant_checkout: 'Instant Checkout',
  content_page_details: 'content page details',
  enter_company_bio: 'Enter company bio',
  shipped_to: 'Shipped to',
  flat_rate_helping_text: 'Enable for flat rate, otherwise charge actual cost.',
  select_the_service: 'Select the service',
  add_new_shipping: 'Add New Shipping',
  edit_shipping: 'Edit Shipping',
  estimated_shipping_fee: 'Estimated Shipping Fee',
  only_showing_carriers: 'Only showing your configured carriers',
  shipping_estimate_needs_details:
    'Enter the weight, length, width and height to calculate the estimated fee.',
  carrier_settings_helping_text:
    "Carrier settings and eligible shipping zones are managed under Shipping configurations. Estimates reflect this product's weight and dimensions.",
  use_flat_rate: 'Use flat rate',
  configuration_summary: 'CONFIGURATION SUMMARY',
  shipping_configuration: 'Shipping Configuration',
  free_shipping_rule: 'Free Shipping Rule',
  free_shipping_when_order_is_over: 'Free shipping when order is over',
  free_shipping_rule_helping_text: 'This will only be applied to orders from this FFL.',
  carrier: 'Carrier',
  service: 'Service',
  average_price: 'Average price',
  estimated_delivery: 'Estimated delivery',
  overnight_delivery: 'Overnight delivery',
  fee_type: 'Fee type',
  delete_product: 'Delete Product',
  notice: 'Notice',
  delete_product_notice_text:
    'Deleting this item will result in a 404 error for external links and negatively impact dealer visibility.',
  mark_as_sold_instead: 'Mark as Sold Instead',
  unknown_vendor: 'Unknown Vendor',
  revenue_financials_data: 'Revenue / financials data',
  send_otp: 'Send OTP',
  verify_otp: 'Verify OTP',
  views_clicks: 'views/clicks',
  pending_orders: 'Pending Orders',
  coupon_data: 'Coupon Data',
  revenue_finanicals_data: 'Revenue / Finanicals Data',
  product_revenue_financials_deleted: 'Product Revenue / financials data will be deleted.',
  product_removed_from_subcategory: 'Product will be removed from sub-category',
  pending_orders_affected_count: '{{count}} pending orders may be affected.',
  associated_views_clicks_deleted: 'Associated {{count}} views/clicks will be deleted.',
  product_coupon_affected: '{{coupon}} Coupon Added to this product.',
  product_rating_reviews_deleted: 'Product rating and reviews will be deleted.',
  coupon_added_to_product: '{{coupon}} Coupon Added to this product.',
  following_permanently_deleted: 'The following will be permanently deleted:',
  permanently_delete_product_msg:
    'This product and all its associated data will be permanently removed.',
  product_listing_data: 'Product listing data.',
  seo_metadata_indexing: 'SEO metadata and indexing.',
  notify_ffl_of_deletion: 'Notify FFL of Deletion',
  permanently_delete: 'Permanently Delete',
  usps_ground_advantage: 'USPS Ground Advantage',
  search_for_variants: 'Search for variants',
  system_suggested_variants: 'System Suggested Variants',
  variant_name: 'variant name',
  // customer panel translations.............................
  // checkout
  continue_shopping: 'Continue Shopping',
  checkout: 'Checkout',
  notify_me: 'Notify Me',
  add_to_cart: 'Add To Cart',
  sold_out: 'Sold Out',
  coupon_removed: 'Coupon removed',
  coupon_discount: 'Coupon discount',
  coupon_saving: '{{code}} saves you',
  coupon_applied_success: 'Coupon {{code}} applied successfully!',
  // Accepted offer pricing
  accepted_offer: 'Accepted Offer',
  offer_savings: 'Offer Savings',
  offer_expired_label: 'Offer expired',
  offer_price_applied: 'Offer price applied to {{product}}',
  offer_price_removed:
    'The accepted offer on {{product}} has expired — the listed price applies again.',
  offer_price_updated: 'The price of {{product}} has been updated.',
  cart_items_unavailable_removed: 'No longer available and removed from your cart: {{names}}',
  cart_offer_prices_updated: 'Some prices in your cart changed because of your accepted offers.',
  product_removed_from_cart: 'Product removed from cart',
  added_to_cart_success_msg: 'Product added to cart!',
  added: 'Added',
  removed: 'Removed',
  added_to_compare_success_msg: 'Added to compare',
  removed_from_compare_success_msg: 'Removed from compare',
  added_to_wishlist_success_msg: 'Added to wishlist',
  removed_from_wishlist_success_msg: 'Removed from wishlist',
  my_wishlist: 'My Wishlist',
  remove_from_compare: 'Remove from compare',
  add_to_compare: 'Add to compare',
  cart_add_to_compare: 'Compare with similar items',
  remove_from_wishlist: 'Remove from wishlist',
  add_to_wishlist: 'Add to wishlist',
  login_required_to_add_in_wishlist: 'Login is required to add into wishlist',
  login_required_to_add_in_compare: 'Please log in to add this product to your compare list.',
  login_required_to_follow_ffl: 'Login is required to follow FFL',
  login_required_to_like_review: 'Login is required to like review',
  buy_now: 'Buy Now',
  shopping_cart: 'Shopping Cart',
  view_cart: 'View Cart',
  empty_cart_title: 'Your Cart is Empty',
  empty_cart_msg: "Looks like you haven't added anything yet",
  subtotal: 'Subtotal',
  tax: 'Tax',
  total: 'Total',
  qty: 'Qty',
  shop_now: 'Shop Now',
  proceed_to_checkout: 'Proceed to Checkout',
  proceed_to_checkout_msg: 'Secure checkout powered by industry-leading encryption',
  paid_through_ffl: 'Paid through FFL',
  order_summary: 'Order Summary',
  search_by_map: 'Search By Map',
  payment_information: 'Payment Information',
  submit_purchase_form: 'Submit Purchase Form',
  transfer_accepted: 'Transfer Accepted',
  accepted: 'Accepted',
  expired: 'Expired',
  buyer_paid: 'Buyer Paid',
  item_shipped: 'Item Shipped',
  manage_shipping_address: 'Manage Shipping Address',
  no_address_msg: 'No saved address found. Add a new one to continue.',
  add_new_address: 'Add New Address',
  payment_failed_error_msg: 'Payment failed, Please try again',
  update_address: 'Update Address',
  save_address: 'Save Address',
  update_and_continue: 'Update & Continue',
  submitted: 'Submitted',
  paid: 'Paid',
  delete_firearm: 'Delete Firearm',
  delete_category: 'delete category',
  delete_category_permanent_msg:
    'Deleting this category will permanently remove all associated data from the system.',
  ffl_listings: 'FFL listings',
  products_will_be_removed: 'products will be removed.',
  subcategories_will_be_deleted: 'subcategories will be deleted.',
  ffl_listings_will_be_affected: 'FFL listings will be affected.',
  category_main_data: 'Category main data.',
  related_product_subcategory_records: 'Related product and subcategory records.',
  associated_analytics_history: 'Associated analytics and history.',
  reviews_and_ratings: 'Reviews and ratings.',
  delete_sub_category: 'delete sub-category',
  delete_subcategory_permanent_msg:
    'You are about to permanently remove this sub-category from the system. This action cannot be undone.',
  listings: ' Listings',
  subcategories: 'Subcategories',
  products_will_be_unassigned_or_hidden: 'products will be unassigned or hidden.',
  active_dealer_listings_will_be_affected: 'active dealer listings will be affected.',
  subcategory_metadata: 'Sub-category metadata.',
  product_associations: 'Product associations.',
  analytics_history: 'Analytics history.',
  select_recipients: 'Select Recipients',
  all: 'All',
  select_all: 'Select All',
  select_all_filtered: 'Select All Filtered',
  vendor: 'Vendor',
  select_group: 'Select Group',
  search_by_name_email_store: 'Search by name, Store, location.',
  // header additional menu
  contact_us: 'Contact US',
  how_to_buy_gun_online: 'How to buy gun online',
  sell_your_gun_to_gun_shops: 'Sell your gun to gun shops',
  // Customer Blog
  trending: 'Trending',
  watch_video: 'Watch Video',
  // Customer Product
  loading_module_data: 'Loading {{ module }}...',
  showing_currentCount_of_totalRecords_of_module_data:
    'Showing {{ currentCount }} of {{ totalRecords }} {{ module }}',
  product_search_placeholder: 'Search for firearms, ammo, accessories...',
  search_products_short: 'Search products...',
  clear_filters: 'Clear Filters',
  price_range: 'Price Range',
  // Customer ffl Map view
  select_ffl_for_local_pickups: 'Select FFL for Local Pick-Ups',
  ffl_locator: 'Gun Shop Locator',
  sell_your_firearms: 'SELL YOUR FIREARMS',
  make_some_money: 'MAKE SOME MONEY',
  start_listing_below: 'Start Listing Below',
  sell_a_firearms_as_a_customer: 'Sell A Firearms as a Customer',
  sell_as_an_ffl: 'Sell as an FFL',
  search_by_name_or_zip: 'Search by name or zip code...',
  find_gun_shop_placeholder: 'Find a gun shop location by',
  searching_or_selecting: 'searching or selecting a location',
  on_the_map: 'on the map',
  search_results_nearby: 'Search results that are near by',
  use_my_location: 'Use My Location',
  featured_ffl: 'Featured FFL',
  unknown_ffl: 'UNKNOWN FFL',
  mi_unit: 'mi',
  deliver_here: 'Deliver Here',
  ffl_delivery_selected: 'Selected',
  get_directions: 'Get Directions',
  location_denied_err: 'Location access was denied. Please allow it in your browser settings.',
  location_denied_feature_err:
    'Location access is denied. Please enable it in your browser settings to use this feature.',
  permissions_api_failed: 'Permissions API query failed:',
  location_outside_usa: 'Location outside USA. Defaulting to general FFL list.',
  store_label: 'Store',
  learn_more: 'Learn More',
  shipping_ffl_placeholder: 'Search preferred FFL',
  shipping_ffl_instruction: 'All order must me shipped directly to an FFL and picked up.',
  shipping_ffl_label: 'Select FFL To Ship To',
  billing_same_as_shipping: 'Billing Same as Shipping Address',
  same_as_shipping_address: 'Same As Shipping Address',
  x_digit_otp: '{{digit}}-digit OTP',
  enter_key: 'Enter {{key}}',
  select_key: 'Select {{key}}',
  view_file: 'View File',
  other_modules: 'Other Modules',
  modules: 'Other Modules',
  Other: 'Other',
  edit_key: 'Edit {{key}}',
  add_key: 'Add {{key}}',
  why_gun_shops_join: 'WHY GUN SHOPS JOIN?',
  customer_ffl_login: 'FFL Login',
  gun_shop_locator: 'GUN SHOP LOCATOR',
  about: 'About',
  // section headings in the mobile menu
  menu_section_shopping: 'Shopping',
  menu_section_services: 'Services',
  menu_section_for_gun_shops: 'For Gun Shops',
  menu_section_help_info: 'Help & Info',
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'Twitter/X',
  youtube: 'Youtube',
  linkedIn: 'LinkedIn',
  mylocal: 'MYLOCAL',
  gunshop: 'GUNSHOP',
  deliver_to: 'Deliver to',
  search_placeholder: 'Search for firearms, ammo, accessories...',
  compare: 'Compare',
  cart: 'Cart',
  menu: 'Menu',
  login_signup: 'LOGIN / SIGNUP',
  shop_all: 'Shop All',
  // profile
  add_new: 'Add New',
  edit_info: 'Edit Info',
  select_ffl_for_shipping: 'Select ffl for shipping',
  choose_ffl: 'Choose FFL',
  set_as_default: 'Set As Default',
  receiver_name: 'Receiver Name',
  address_name: 'Address Name',
  deault_address: 'Default Address',
  // home page
  varients: 'Varients',
  top_featured_ffls: 'TOP / FEATURED FFLS',
  no_ffl_found: 'No FFL Found',
  top_sellers: 'Top sellers',
  top_seller: 'TOP SELLERS',
  top_seller_sub_title: 'Get products from our new collections',
  discounted_products_desc: 'Get up to {{discount}}% OFF',
  new_buyer_resources: 'New Buyer Resources',
  recently_viewed: 'Recently Viewed',
  discounted_products: 'Discounted Products',
  top_deals: 'Top Deals',
  top_deal: 'Top Deal',
  shop_all_deals: 'Shop All Deals',
  top_deals_sub_title: 'Find great deals on top products',
  new_collection_sub_title: 'Get products from top dealers',
  fresh_listings: 'Fresh Listings',
  fresh_listings_sub_title:
    'Discover random marketplace listings from certified dealers nationwide.',
  expert_insights_and_community_reviews: 'Expert Insights & Community Reviews',
  expert_insight_community_sub_title: 'Buyers, dealers, and shooters',
  refresh: 'Refresh',
  shop_by_state: 'Shop By State',
  compliant_by_design: 'Compliant by design',
  new_collection: 'New Collection',
  popular_categories: 'Popular Categories',
  suggested: 'Suggested',
  guns_near_you: 'Guns near you',
  discounted_listings: 'Discounted Listings',
  promoted_listings: 'Promoted Listings',
  brands: 'Brands',
  // sell your firearms
  sell_my_firearm: 'Sell My Firearm',
  need_help: 'Need help?',
  sell_as_a_ffl: 'Sell as an FFL',
  sell_as_a_ffl_title: 'Track Your Business Firearms Sales',
  sell_as_a_customer: 'Sell as a Customer',
  sell_as_a_customer_title: 'Track Your Firearms Trade-Ins',
  sell_as_a_guest: 'Begin Your Trade-In As A Guest',
  continue_as_guest: 'Continue as Guest',
  trade_in_offers: 'Trade-In Offers',
  recommended: 'Recommended',
  additional: 'Additional',
  photos: 'Photos',
  fill_out_product_details_below: 'Fill out product details below.',
  sell_my_firearm_description_placeholder:
    'Describe the technical craftsmanship and editorial features...',
  next_step: 'Next Step',
  additional_notes: 'Additional Notes',
  whats_included: 'Whats Included',
  do_you_have_the_original_box_case: 'Do you have the original box/case?',
  do_you_have_the_original_papers: 'Do you have the original papers?',
  do_you_have_the_original_papers_sub_text: '(manual, warranty card, test target, etc.)',
  do_you_have_any_magazines_accessories:
    'Do you have any magazines, ammunition, optics or any other accessories you’d like to sell with this gun?',
  is_this_an_nfa_item: 'Is this an NFA item?',
  select_condition: 'Select Condition',
  has_the_gun_been_modified: 'Has the gun been modified or have any parts been replaced?',
  trade_in: 'Trade-in',
  modification_description: 'Modification description',
  please_describe_aftermarket_parts: 'Please describe aftermarket/replacement parts',
  please_describe_parts_added: 'Please description the parts added to the gun',
  im_unsure: "I'm Unsure",
  anything_else_you_would_like_to_share: 'anything else you would like to share with us?',
  signature_attestation_text:
    'By signing here, the above named attest that the or she is the seller of this firearm and has read and agrees to the My LocalGunShop & MyLocalGunShop.com LLC Terms and Conditions.',
  photos_instruction_text:
    'Please provide high quality images for at least the left, right and entire firearm. Any additional close ups of firearm mechanics would be helpful.',
  contact_instruction_text:
    "Select your preferred contact method. We'll send a verification email to publish your listing. Already have an account? Login.",
  contact_email_placeholder: 'E.g. johndoe@gmail.com',
  contact_first_name_placeholder: '(e.g. John)',
  contact_last_name_placeholder: '(e.g. Doe)',
  contact_address_placeholder: 'Street address and suite/unit',
  contact_zip_code_placeholder: '00000',
  contact_phone_placeholder: '2125551234',
  enter_description: 'Enter description',
  sell_firearm_complete_previous_steps: 'Please complete all required fields first.',
  submit_firearm_for_sale: 'Submit Firearm For Sale',
  built_for_the_way_you_sell: 'Ready to put your FFL on the map?',
  everything_you_need_to_run_your_online_storefront:
    'Everything you need to run your online storefront without changing how your shop already works.',
  no_followings: 'No Followings',
  ffl_other_product: "FFL's Other Products",
  similar_listings: 'Similar Listings',
  customer_reviews: 'Customer Reviews',
  gun_shop_reviews: 'Gun Shop Reviews',
  add_review: 'Add Review',
  submit_review: 'Submit Review',
  submitting: 'Submitting',
  upload_images_or_video: 'Upload image or video',
  write_your_review_here: 'Write your review here',
  ffl_coupons_header_msg:
    'Get some great discount with this FFL with the coupons below. Copy and Paste them at checkout.',
  message_seller: 'Message Seller',
  latest: 'Latest',
  official_responses: 'Official Responses',
  lowest_rated: 'Lowest Rated',
  highest_rated: 'Highest Rated',
  top_rated: 'Top Rated',
  oldest: 'Oldest',
  no_reviews_found: 'No Reviews Found',
  follow_unfollow_ffl_success_msg: 'FFL {{action}} successfully',
  like_unlike_success_msg: '{{action}} successfully',
  full_screen: 'Full Screen',
  liked: 'Liked',
  unliked: 'Unliked',
  favorite_ffl: 'Favorite FFL',
  review_added_success_msg: 'Review Added successfully',
  review_details: 'Review Details',
  review_media_support_note: 'Support For High-Res {{formats}} Up To {{maxSize}}MB',
  // compare modal
  remove: 'Remove',
  compare_items: 'Compare Items',
  compare_multiple_products: 'Compare multiple products',
  compare_empty_title: 'Nothing to Compare',
  compare_empty_msg: 'Add products from the listing page to start comparing them side by side.',
  clear_all: 'Clear All',
  compare_now: 'Compare Now',
  specifications: 'Specifications',
  indicators: 'Indicators',
  starting_at: 'Starting At',
  please_enter_valid_offer_price: 'Please enter a valid offer price',
  spec_caliber: 'Caliber',
  spec_barrel_length: 'Barrel Length',
  spec_capacity: 'Capacity',
  spec_action: 'Action',
  spec_weight: 'Weight (Unloaded)',
  spec_overall_length: 'Overall Length',
  spec_height: 'Height',
  spec_width: 'Width',
  spec_frame: 'Frame Material',
  spec_slide: 'Slide Material',
  spec_finish: 'Finish',
  spec_sights: 'Sights',
  spec_safety: 'Safety Type',
  spec_trigger_pull: 'Trigger Pull',
  spec_grip: 'Grip Type',
  spec_rail: 'Rail System',
  spec_threaded_barrel: 'Threaded Barrel',
  spec_origin: 'Country of Origin',
  spec_price: 'Price',
  connect: 'Connect',
  // ffl detail page
  gallery: 'Gallery',
  this_seller_ship: 'This Seller Ships',
  about_us: 'About Us',
  specialities: 'Specialities',
  contact_information: 'Contact Information',
  location_and_hours: 'Location & Hours',
  closed: 'Closed',
  open: 'Open',
  following: 'Following',
  favorites: 'Favorites',
  view_all_coupons: 'View All Coupons',
  product_specs: 'Product Specs',
  caliber_all: 'Caliber: All',
  manufacturer_all: 'Manufacturer: All',
  product_unit: 'Unit',
  product_units: 'Units',
  coupon_more_count: '+{{count}} more',
  show_less: 'Show less',
  products_selected_count: '{{count}} selected',
  clear_selection: 'Clear selection',
  bulk_mark_active: 'Mark Active',
  bulk_mark_archived: 'Archive',
  bulk_mark_sold: 'Mark Sold',
  bulk_status_confirm_title: 'Change product status',
  bulk_status_confirm_message: 'Change {{count}} selected product(s) to {{status}}?',
  bulk_status_success_message: '{{count}} product(s) changed to {{status}}.',
  min_price_placeholder: 'Min',
  max_price_placeholder: 'Max',
  guns_for_sale_product_view: 'Guns For Sale Product View',
  firearm_submitted_for_purchase: 'Firearm Submitted For Purchase',
  firearm_submitted_for_purchase_banner: 'Firearm submitted for purchase',
  described_modifications_and_parts_replaced: 'Described Modifications & Parts Replaced:',
  submission_date: 'Submission Date',
  described_modifications_parts_replaced: 'DESCRIBED MODIFICATIONS / PARTS REPLACED',
  anything_else_you_would_like_to_share_with_us: 'Anything else you would like to share with us?',
  confidential_document_auto_generated_by: 'Confidential Document • Auto Generated by ',
  mylocal_gun_shop_brand: 'My Local Gun Shop',
  seller_details: 'Seller Details',
  do_you_have_any_accessories:
    "Do you have any magazines, ammunition, optics or any other accessories you'd like to sell with this gun?",
  includes_additional_accessories_default:
    'Includes additional accessories: magazine, soft case, and basic cleaning kit.',
  year_of_manufacture: 'Year of Manufacture',
  no_description_provided: 'No description provided.',
  no_additional_notes_provided: 'No additional notes provided.',
  print_form: 'Print Form',
  store_status: 'Store status',
  directory_links: 'Directory Links',
  business_directory_links: 'BUSINESS DIRECTORY LINKS',
  shippings: 'Shippings',
  powered_by: 'Powered by',
  add_shipping: 'Add Shipping',
  search_terms: 'Search Terms',
  search_terms_page_description: 'Manage all your search terms below.',
  search_location: 'Search Location',
  search_location_all: 'Search Location: All',
  global_search: 'Global Search',
  product_search: 'Product Search',
  keyword: 'Keyword',
  original_keyword: 'Original Keyword',
  total_search: 'Total Search',
  last_search_at: 'Last Search At',
  personal_information: 'Personal Information',
  store_settings: 'Store Settings',
  integration: 'Integration',
  social_links: 'Social Links',
  social_links_description:
    'Add your official social media profile links below to help customers easily discover and connect with your business across different platforms.\nThese links also strengthen your online presence and make your brand more accessible and trustworthy.',
  reviews_links: 'Reviews Links',
  reviews_links_description:
    'Add your business review profile links below to help us aggregate and display your existing ratings from external platforms. These links are used to connect your business reviews and improve your profile credibility.',
  free_shipping_rules: 'Free Shipping Rule',
  add_rule: 'Add Rule',
  add_free_shipping_rule: 'Add Free Shipping Rule',
  edit_free_shipping_rule: 'Edit Free Shipping Rule',
  free_shipping_applies_to: 'Applies To',
  free_shipping_conditions: 'Conditions',
  free_shipping_type_category: 'Category',
  free_shipping_type_sub_category: 'Sub-Category',
  free_shipping_type_product: 'Specific Products',
  free_shipping_type_bundle: 'Bundle (bought together)',
  free_shipping_min_spend: 'Minimum Spend ($)',
  free_shipping_min_quantity: 'Minimum Quantity',
  free_shipping_product_help: 'Each selected product gets free shipping on its own.',
  free_shipping_bundle_help:
    'Free shipping applies only when every selected product is in the cart together.',
  free_shipping_bundle_min_products: 'Select at least 2 products for a bundle',
  free_shipping_no_minimum: 'Always free',
  free_shipping_min_spend_value: 'Spend ${{amount}}+',
  free_shipping_min_quantity_value: 'Buy {{count}}+ items',
  free_shipping_names_more: '{{names}} and {{count}} more',
  free_shipping_target_named_items: '"{{name}}" items',
  free_shipping_target_category_empty: 'items in the selected category',
  free_shipping_target_sub_category_empty: 'items in the selected sub-category',
  free_shipping_target_products: 'units of {{names}}',
  free_shipping_target_products_empty: 'units of the selected products',
  free_shipping_target_bundle: 'bundle items ({{names}})',
  free_shipping_target_bundle_empty: 'bundle items',
  free_shipping_rule_summary: 'Rule summary',
  free_shipping_summary_pending:
    'Choose what the rule applies to and enter the minimum spend to see the rule summary.',
  free_shipping_chip_bundle: 'All bundle items',
  free_shipping_summary_always: 'Shipping is always free on {{target}}.',
  free_shipping_summary_conditional: 'Shipping is free on {{target}} when {{conditions}}.',
  free_shipping_condition_bundle: 'every bundle product is in the cart',
  free_shipping_condition_spend: 'they add up to ${{amount}} or more',
  free_shipping_condition_quantity: 'the cart has {{count}} or more of them',
  free_shipping_condition_and: ' and ',
  enter_amount: 'Enter amount',
  dont_see_integration: "Don't see your integration?",
  integration_request_description:
    'Let us know which tools you use for your FFL operations. Our engineering team regularly reviews integration requests to expand our ecosystem.',
  send_request: 'Send Request',
  integration_request_subject: 'FFL Integration Request',
  integration_request_email_body:
    'Hi Support Team,\n\nI would like to request a new integration for my FFL operations.\n\nTools/Integrations I would like to request:\n- [List tools here]\n\nFFL Business Details:\n- Business Name: {{businessName}}\n- FFL License: {{fflNo}}\n\nThank you!',
  sms_logs: 'SMS Logs',
  sms_log_page_description: 'Manage all your SMS logs below.',
  provider: 'Provider',
  sent: 'Sent',
  start_your_listing_with_a_product_link: 'Start your listing with a product link',

  actions: 'Actions',
  admin_attachment: 'Admin Attachment',
  age: 'Age',
  ammunition: 'Ammunition',
  amount: 'Amount',
  appoinment_only: 'Appointment Only',
  at_least_one_address_required: 'At least one address required',
  authors: 'Authors',
  blog_status: 'Blog Status',
  business_email: 'Business Email',
  buyer_pays_actual_shipping_cost: 'Buyer pays actual shipping cost',
  buyer_pays_fixed_amount: 'Buyer pays fixed amount',
  cms: 'CMS',
  connect_integrations: 'Connect Integrations',
  connected: 'Connected',
  copied_success: 'Copied successfully',
  coupon: 'Coupon',
  coupons: 'Coupons',
  cvv: 'CVV',
  describe_the_technical_craftsmanship_and_editorial_features:
    'Describe the technical craftsmanship and editorial features...',
  drafts: 'Drafts',
  drag: 'Drag',
  drag_and_drop_media_or_browse: 'Drag And Drop Media Or Browse',
  drag_and_drop_up_to_max_images: 'Drag and drop up to {{maxImages}} high-resolution images',
  e_g_76c16385: 'e.g., 76C16385',
  e_g_ar_15: 'e.g., AR-15',
  e_g_700_tactical: 'e.g. 700 Tactical',
  e_g_precision_arms: 'e.g. Precision Arms',
  e_g_precision_marksman_tactical_series_x: 'e.g. Precision Marksman Tactical Series X',
  each: 'each',
  errors: 'Errors',
  essentials: 'Essentials',
  excellent: 'Excellent',
  expand: 'Expand',
  failed_to_fetch_profile: 'Failed to fetch profile',
  failed_to_reset_menu_order: 'Failed to reset menu order',
  fair: 'Fair',
  ffl_dealer: 'FFL Dealer',
  filters: 'Filters',
  firearm: 'Firearm',
  followed: 'Followed',
  free_shiping: 'Free Shipping',
  from: 'From',
  good: 'Good',
  group: 'Group',
  guns_for_sale_page_description: 'Manage all guns for sale below.',
  help_me_upload: 'Help me upload',
  ffl_license_upload_tooltip:
    'Upload a clear, current copy of your FFL license. We use it to verify your dealer account.',
  import: 'Import',
  invalid_value: 'Invalid value for {{key}}',
  inventory: 'Inventory',
  item: 'Item',
  keywords: 'Keywords',
  link: 'Link',
  loading: 'Loading',
  logistics: 'Logistics',
  manufacture: 'Manufacturer',
  max_column_allow_list_error_msg: 'Maximum allowed columns exceeded for {{key}}',
  max_column_filter_list_error_msg: 'Maximum allowed filter columns exceeded for {{key}}',
  menu_order_reset_successfully: 'Menu order reset to default successfully',
  merchandise: 'Merchandise',
  firearms_and_accessories: 'Firearms and Accessories',
  mfg: 'Mfg.',
  min_column_allow_list_error_msg: 'Minimum allowed columns not met for {{key}}',
  min_column_filter_list_error_msg: 'Minimum allowed filter columns not met for {{key}}',
  module: 'Module',
  monthly: 'Monthly',
  negotiations: 'Negotiations',
  no_backlink_url: 'No backlink URL',
  no_channels_selected: 'No channels selected',
  no_description_available: 'No description available',
  no_drafts_found: 'No drafts found',
  only_image_and_pdf: 'Only image and PDF files are allowed',
  only_image_as_list_but_multiple_with_api: 'Only image as list but multiple with API',
  others: 'Others',
  password_update_failed: 'Password update failed',
  pdf_download_successfull_message: 'PDF downloaded successfully',
  personal_email: 'Personal Email',
  phone: 'Phone',
  plan: 'Plan',
  previous: 'Previous',
  pricing: 'Pricing',
  recommended_image_size_note: 'Recommended size: {{width}}x{{height}}px.',
  min_photos_for_premium_listings: 'Min {{count}} photos for premium listings.',
  reorder: 'Reorder',
  required_field_name: 'Required field: name',
  sales: 'Sales',
  save: 'Save',
  select_active_promotion_coup: 'Select Active Promotion & Coupon',
  sellers: 'Sellers',
  sending: 'Sending',
  receiving: 'Receiving',
  seo: 'SEO',
  sidebar_menu_configuration: 'Sidebar Menu Configuration',
  signature: 'Signature',
  single_image: 'Single image',
  slug: 'Slug',
  sms: 'SMS',
  stock: 'Stock',
  'sub-category': 'Sub-Category',
  sub_categories: 'Sub-Categories',
  subject_line_here: 'Subject line here',
  submission: 'Submission',
  submission_id: 'Submission ID',
  trasfer_fee: 'Transfer Fee',
  uncategorized: 'Uncategorized',
  unfollowed: 'Unfollowed',
  update_password: 'Update Password',
  update_product_status: 'Update Product Status',
  upload_from_computer: 'Upload from computer',
  upload_from_device: 'Upload from Device',
  uploading: 'Uploading',
  used: 'Used',
  usps: 'USPS',
  validity_period_required: 'Validity period is required',
  wishlist: 'Wishlist',
  yearly: 'Yearly',
  disconnect: 'Disconnect',
  first_disconnect_shipping_carrier:
    'First disconnect {{name}} shipping carrier then only you can configure a new one',
  first_disconnect_payment_gateway:
    'First disconnect {{name}} payment gateway then only you can configure a new one',
  first_update_address_from_the_profile_menu: 'First update address from the profile menu',
  update_transfer_request_status: 'Update Transfer Request Status',
  calculating_totals: 'Calculating Totals...',
  // tooltip..............................................................................
  seo_tooltip:
    'Search Engine Optimization settings to help search engines find and index this product.',
  sales_channels_tooltip: 'Select where this product should be available for purchase.',
  product_visibility_tooltip:
    'Control how and where this product is displayed in public listings (e.g., featured or new arrivals).',
  promotion_coupon_codes_tooltip:
    'Link discount coupon codes to this product for promotional offers.',
  product_variations_tooltip: 'Add different variations of this product.',
  product_status_tooltip: 'Change the visibility and editing status of the product.',
  pricing_tab_tooltip: 'Set up the asking price, discounted price, and stock levels.',
  tax_tab_tooltip: 'Configure tax class and tax percentages.',
  negotiations_tooltip: 'Enable buyers to make offers and set automatic acceptance thresholds.',
  discounted_price_tooltip:
    'The selling price of the product after discounts. If no discount, match the asking price.',
  same_as_asking_price: 'Same as asking price',
  tax_value_tooltip: 'Calculated tax amount based on the selected tax type and percentage rate.',
  organization_tooltip: 'Specify the organization or shop this product belongs to.',
  logistics_tab_tooltip:
    'Specify physical product specifications like weight and dimensions for shipping calculation.',
  shipping_configuration_tab_tooltip:
    'Configure shipping provider, estimated delivery times, and handling time details.',
  general_information_tooltip:
    'Basic details about the product, including its title and detailed description.',
  product_live_preview_tooltip:
    'A real-time preview of how this product will be displayed to customers on the website.',
  backlink_url_tooltip: "The source URL or external product link for this item's listing.",
  store_descriptions_tooltip: 'A brief overview or bio of your gun shop visible to customers.',
  speciality_tooltip:
    'Any specific areas of expertise or firearm categories your shop specializes in.',
  services_tooltip:
    'Specific gunsmithing or transfer services provided directly at your shop. Separate multiple services with a comma (e.g. Gunsmithing, FFL Transfers, Cerakoting) - each one shows as its own tag on your shop page.',
  product_images_tooltip:
    'Upload high-quality images of the product. Drag to reorder, with the first image set as the main photo.',
  technical_specifications_tooltip:
    'Key technical attributes, specifications, and details of the product.',
  handgun_photo_tooltip: 'View recommended photo angles and examples for handguns.',
  long_gun_photo_tooltip: 'View recommended photo angles and examples for long guns.',
  find_nearby_firearm_stores_title:
    'FIND NEARBY FIREARM STORES IN <span class="text-orange">MINUTES</span>',
  find_nearby_firearm_stores_desc1:
    'Looking for a reliable gun shop nearby? Our nationwide firearm dealer map helps you locate licensed gun stores, FFL transfer dealers, shooting supply stores, and firearm service providers with ease. Use the interactive map to explore shops by city, state, or ZIP code and discover the closest locations that match your needs.',
  find_nearby_firearm_stores_desc2:
    'Whether you are shopping for your next firearm, searching for ammo, or arranging an FFL transfer, our locator gives you a fast and user-friendly way to find trusted firearm dealers throughout the United States.',
  built_for_the_way_you_sell_desc:
    'Everything you need to run your online storefront without changing how your shop already works.',
  gun_shops_in_texas_title: 'GUN SHOPS IN <span class="text-orange">{{stateUpper}}</span>',
  gun_shops_in_texas_desc:
    'Explore firearm dealers, hunting stores, and FFL transfer locations across major {{state}} cities{{citiesSuffix}}.',
  gun_detail_label: 'Tell FFLs about your gun',
  box_incl: 'BOX INCL',
  modified_item: 'MODIFIED',
  papers_incl: 'PAPERS INCL',
  extra_included: 'EXTRA INCLUDED',
  nfa_item_badge: 'NFA ITEM',
  view_details: 'View Details',
  submitted_for_sale_trade_in: 'SUBMITTED FOR SALE/TRADE-IN',
  mark_firearm_sold: 'MARK FIREARM SOLD',
  who_did_you_sell_to: 'Who did you sell this too?',
  search_or_select_ffl: 'Search or select FFL',
  someone_on_another_platform: 'Someone on another platform',
  type_name_of_platform: 'Type name of platform',
  how_much_did_you_sell_for: 'How much did you sell it for?',
  input_price: 'Input price',
  why_are_you_deleting_this_firearm: 'Why are you deleting this firearm?',
  expected_delivery: 'Expected Delivery',
  in_stock_free_delivery: 'In-stock • Free Delivery',
  promo_applied: 'Promo applied',
  order_total: 'Order Total',
  before_you_checkout: 'BEFORE YOU CHECKOUT',
  firearms_cannot_be_shipped: 'Firearms cannot be shipped to your residence.',
  firearms_must_be_transferred: 'Firearms must be transferred through a licensed FFL dealer.',
  complete_atf_form_4473: 'Must complete ATF Form 4473 / background check at pickup.',
  compare_your_favorite_or_search: 'COMPARE YOUR FAVORITE OR SEARCH',
  be_aware_of_ffl_fees: 'Be aware of any FFL transfer fees.',
  notify_receiving_ffl: 'Notify your receiving FFL before shipment.',
  bring_valid_photo_id: 'Bring a valid government-issued photo ID.',
  state_local_laws_affect_pickup: 'State and local laws may affect pickup requirements.',
  ammo_deliveries_require_signature: 'Ammo deliveries may require an adult signature (21+).',
  united_states: 'United States',
  business_hours_uppercase: 'BUSINESS HOURS',
  items_uppercase: 'ITEM(S)',
  items_lowercase: 'Items(s)',
  selected_pickup_ffl: 'SELECTED PICKUP FFL',
  change: 'Change',
  address_details_not_available: 'Address details not available',
  view_all_working_hours: 'View All Working Hours',
  contact_uppercase: 'CONTACT',
  no_destination_gun_shop_selected:
    'No destination gun shop selected yet. Please select an FFL location for firearm transfer.',
  personal_information_uppercase: 'PERSONAL INFORMATION',
  personal_info_short_uppercase: 'PERSONAL INFO.',
  billing_information_uppercase: 'BILLING INFORMATION',
  same_as_shipping_address_uppercase: 'SAME AS SHIPPING ADDRESS',
  custom_billing_address: 'Custom Billing Address',
  ammo_ships_ground: 'Ammo ships ground,',
  available_ammo_matching: 'Available ammo matching this firearm',
  adult_signature_required: 'adult signature (21+)',
  optics_accessories_ship_standard: 'required. Optics & accessories ship standard.',
  no_personal_info_saved: 'No personal info saved yet. Please enter your shipping address below.',
  order_includes_items_from: 'Your order includes items from',
  dealers_pay_directly_notice:
    "You pay each dealer directly - every charge runs through that dealer's own payment gateway, never through My local gun shop.",
  your_cart_is_empty: 'Your cart is empty.',
  edit_billing_information: 'EDIT BILLING INFORMATION',
  close_modal: 'Close modal',
  billing_address_is_same_as_shipping: 'Billing address is same as shipping address',
  billing_address_same_as_shipping: 'Billing Address (Same As Shipping)',
  enter_billing_address: 'Enter Billing Address',
  edit_personal_shipping_information: 'EDIT PERSONAL / SHIPPING INFORMATION',
  enter_contact_shipping_address: 'Enter Contact & Shipping Address',
  select_shipping_address_personal_info: 'SELECT SHIPPING ADDRESS / PERSONAL INFORMATION',
  shipping_address_personal_info: 'SHIPPING ADDRESS / PERSONAL INFORMATION',
  shipping_address_personal_info_note:
    'Any items not requiring shipment to an FFL for transfer will be sent to the address below.',
  billing_same_as_shipping_address: 'Billing Same as Shipping Address',
  view_order_status: 'View Order Status',
  coupon_applied: 'Coupon Applied',
  coupons_applied: 'Coupons Applied',
  multiple_coupons_allowed_hint:
    'This seller lets you combine coupon codes - enter another code to add it.',
  applied: 'Applied',
  apple_pay_unavailable: 'Apple Pay is not available right now. Please try another payment method.',
  apple_merchant_id: 'Apple Pay Merchant ID',
  apple_merchant_id_hint:
    "Optional. The Apple Merchant ID registered for this FFL's Authorize.Net account. Leave empty to turn Apple Pay off.",
  select_delivery_type: 'Select Delivery Type',
  flat_rate_shipping: 'Flat Rate Shipping',
  local_pickup: 'Local Pickup',
  shipping_method_uppercase: 'SHIPPING METHOD',
  payment_uppercase: 'PAYMENT',
  placeholder_first_name: 'e.g. John',
  placeholder_last_name: 'e.g. Martin',
  placeholder_phone: '2125551234',
  placeholder_email: 'e.g. John@gmail.com',
  remove_coupon: 'Remove coupon',
  order_confirmed: 'Order Confirmed!',
  order_confirmed_subtitle: 'Thank you for your purchase. Your order has been successfully placed.',
  thank_you_for_purchase:
    'Thank you {{name}} for your purchase. Your order has been successfully placed.',
  whats_next: "What's Next?",
  receive_email_shortly: "You'll receive an order confirmation email shortly.",
  send_shipping_updates: "We'll send shipping updates to your email.",
  estimated_delivery_business_days: 'Estimated delivery: 5-7 business days.',
  payment_goes_directly_to_seller: 'Payment goes directly to the seller — never stored by MLGS.',
  select_item_to_assign_shipping_method: 'Select The Item To Assign Shipping Method.',
  standard_shipping: 'Standard Shipping',
  est_delivery_prefix: 'Est. Delivery:',
  handling_time_prefix: 'Handling time:',
  standard_delivery_calculated_at_checkout: 'Standard Delivery (Calculated at checkout)',
  cardholder_name_placeholder: 'Cardholder Name',
  card_number_placeholder: 'xxxx - xxxx - xxxx - xxxx',
  expiry_date_placeholder: 'MM/YY',
  cvv_placeholder: '123',
  change_shipping_ffl: 'Change Shipping FFL',
  note_label: 'Note:',
  will_be_sent_to_gun_shop: 'will be sent to selected Gun Shop (FFL)',
  two_business_days: '2 BUSINESS DAYS',
  help_live_support: 'Live Support Available',
  help_call_or_text: 'Call Or Text',
  help_users_resolve_using_search: 'of users resolve issues using search',
  help_popular_searches: 'Popular Searches',
  help_what_need_help_with: 'What do you need help with?',
  help_category_buying_online: 'Buying Online',
  help_category_about_mlgs: 'About MLGS',
  help_category_general: 'General',
  help_category_account_issue: 'Account Issue',
  help_general_questions: 'General Questions',
  help_built_for_way_you_sell: 'BUILT FOR THE WAY YOU SELL.',
  help_search_placeholder: 'Search Anything...',
  help_no_general_questions_match: 'No general questions match your search.',
  help_no_seller_topics_match: 'No seller support topics match your search.',
  help_results_matching: 'results matching',
  help_reset_search: 'Reset Search',
  lets_resolve_your_issues: "LET'S RESOLVE YOUR ISSUES",
  help_subtitle: "Need assistance? We're here to help with any questions or issues you may have.",
  help_results_matching_found: 'Found',
  help_general_questions_subtitle: 'Basics, terminology, and firearm fundamentals',
  help_shopping_questions: 'Shopping',
  help_shopping_questions_subtitle: 'How to browse, order, and pay online',
  help_shipping_questions: 'Shipping',
  help_shipping_questions_subtitle: 'Understanding the transfer process and fees',
  help_no_shopping_questions_match: 'No shopping questions match your search.',
  help_no_shipping_questions_match: 'No shipping questions match your search.',
  help_pickup_questions: 'Gun Pickup',
  help_pickup_questions_subtitle: 'What to do and expect when picking up your firearm',
  help_no_pickup_questions_match: 'No pickup questions match your search.',
  help_trade_ins_questions: 'Trade-Ins',
  help_trade_ins_questions_subtitle: 'Selling or trading your gun to verified local shops',
  help_no_trade_ins_questions_match: 'No trade-in questions match your search.',
  help_trade_in_photos_questions: 'Taking Photos for Trade-In Offers',
  help_trade_in_photos_questions_subtitle: 'Tips for getting the best offers for your firearm',
  help_no_trade_in_photos_questions_match: 'No photo guide topics match your search.',
  help_ffl_questions: 'How to Become an FFL',
  help_ffl_questions_subtitle: 'Licensing requirements, costs, and the ATF process',
  help_no_ffl_questions_match: 'No FFL questions match your search.',
  delete_account: 'Delete Account',
  action_permanent: 'This action is permanent.',
  delete_account_warn_msg:
    'Deleting your account will remove your profile, saved addresses, favorites, and notification settings.',
  trade_ins: 'Trade-ins',
  order_value: 'Order Value',
  following_will_be_deleted: 'The following will be deleted:',
  account_billing_info: 'Account and Billing Information',
  cart_saved_items: 'Cart and Saved Items',
  recently_viewed_products: 'Recently viewed Products',
  saved_ffls: 'Saved FFLs',
  payment_methods: 'Payment Methods',
  order_data_deleted: 'Order data will be deleted.',
  trade_in_data_deleted: 'Trade-in data will be deleted.',
  pending_orders_affected_msg: '{{count}} pending orders may be affected.',
  product_compare_deleted: 'Product compare list will be deleted.',
  rating_reviews_deleted: 'Rating and reviews will be deleted.',
  saved_addresses_deleted: 'Saved Addresses will be deleted.',
  notification_preferences_deleted: 'Notification Preferences Settings will be deleted.',
  type_delete_to_confirm: 'Type DELETE To Confirm:',
  type_delete_here_placeholder: 'Type "delete" here',
  understand_action_cannot_undone: 'I understand this action cannot be undone.',
  // Customer Checkout additions
  select_shipping_ffl_dealer: 'Select Shipping FFL Dealer',
  today_prefix: 'Today:',
  closed_today: 'Closed Today',
  transfer_fee_colon: 'Transfer fee :',
  enter_code: 'Enter Code',
  please_enter_a_coupon_code: 'Please enter a coupon code',
  preferred_ffl_is_required: 'Preferred FFL is required',
  payment_method_is_required: 'Payment method is required',
  card_number_is_required: 'Card number is required',
  name_on_card_is_required: 'Name on card is required',
  expiry_date_is_required: 'Expiry date is required',
  cvv_is_required: 'CVV is required',
  submit_order: 'Submit Order',
  pay: 'PAY',
  payment_unavailable: 'Payment Unavailable',
  shipping_free_ships_to_ffl: 'Shipping — Free',
  sales_tax: 'Sales tax',
  charge_from: 'Charge from',
  invoice_payment_info: 'INVOICE & PAYMENT INFORMATION',
  your_ffl_will_review_request:
    'Your FFL will review your request and send you an invoice with payment instructions.',
  select_payment_method_for_ffl:
    "Select The Payment Method You'd Like To Use For The FFL Transaction.",
  business_day_singular: 'BUSINESS DAY',
  business_days_plural: 'BUSINESS DAYS',
  selected_shipping_methods: 'Selected Shipping Methods',
  color: 'COLOR',
  size_selection: 'SIZE SELECTION',
  size_guide: 'SIZE GUIDE',
  keep_scrolling: 'KEEP SCROLLING',
  the_next_product_is_loading_below: 'The next product is loading below.',
  next_product_loading_below: 'The next product is loading below.',
  loading_next_product: 'Loading next product...',
  scroll_back_up: 'SCROLL BACK UP',
  previous_product_loading_above: 'The previous product is loading above.',
  loading_previous_product: 'Loading previous product...',
  explore_rifles_description:
    'Explore rifles built for hunting, sport shooting, and personal defense. MLGS connects buyers with trusted local gun shops offering new, used, and historic bolt-action, semi-automatic, AR-style, and precision rifles from leading firearm brands across the United States.',
  sidebar_category_description:
    'From precision bolt-actions to modern sporting rifles, explore dependable options built for hunting, tactical use, range fun, target shooting, and personal defence. Compare trusted rifle brands, calibers, barrel lengths, variations and configurations from verified dealers across the country. Browse new, used, and historic rifles.',
  explore_merchandise_description:
    'Explore high-quality merchandise, apparel, and accessories. MLGS connects buyers with trusted local gun shops offering exclusive gear and branded merchandise to complement your lifestyle.',
  sidebar_merchandise_description:
    'Browse top-quality apparel and accessories. Find exclusive branded merchandise, tactical gear, and everyday wear from your favorite firearm brands and local shops.',
  learn_more_here: 'Learn more here:',
  view_product: 'View Product',
  // `gun_shop_locator` is upper case for the nav bar; this is the in-sentence spelling.
  gun_shop_locator_label: 'Gun Shop Locator',

  // Shipping related strings
  shipping_method_required_or_manual_msg:
    'Either shipping method is required or use free shipping or flat shipping rate method.',
  manual_shipping_warning_title: 'Manual Shipping Required',
  manual_shipping_warning_desc:
    "You are listing a product without a shipping method. In this case, you will have to handle shipping manually and update order statuses from the order listing page for the user's convenience.",
  must_use_flat_rate_no_carrier: 'Flat rate is required as no carrier is configured.',
  order_reports: 'Order Reports',
  order_reports_page_description: 'View all your previous order reports below.',
  reported_by: 'Reported By',
  reported_by_email: 'Reported By Email',
  order_all: 'Order: All',
  user_all: 'User: All',
  reason: 'Reason',
  report_detail: 'Report Detail',

  integration_requests: 'Integration Requests',
  integration_requests_page_description:
    'Manage marketplace integration requests and monitor integration status and health.',
  support_requests: 'Support Requests',
  product_help_requests: 'Product Help Requests',
  product_help_requests_page_description:
    'Manage product help requests and monitor product help request status and health.',

  field_requests: 'Field Requests',
  field_requests_page_description:
    'Manage field requests and monitor field request status and health.',
  select_or_create: 'Select or Create',
  option_name: 'Option Name',
  save_for_later: 'Save for later',

  // Order Return
  return_order_item: 'Return Order Item',
  request_item_return: 'Request Item Return',
  select_items_to_return: 'Select Items to Return',
  return_reason: 'Return Reason',
  select_return_reason: 'Select a return reason',
  return_remarks: 'Remarks / Additional Details',
  return_remarks_placeholder: 'Describe the issue or cosmetic damage in detail...',
  return_photos: 'Item / Damage Photos',
  upload_photos_description: 'Upload clear photos of the item or package (PNG, JPG, WEBP)',
  at_least_one_item_return_required: 'Please select at least one item to return',
  reason_required_for_all_selected_items: 'Please specify a return reason for each selected item',
  return_request_submitted_successfully: 'Return request submitted successfully!',
  defective_item: 'Defective item',
  wrong_item_delivered: 'Wrong item delivered',
  item_damaged_in_transit: 'Item damaged in transit',
  missing_parts_or_accessories: 'Missing parts or accessories',
  item_arrived_late: 'Item arrived late',
  does_not_fit_or_function: 'Does not fit or function as expected',
  custom_reason: 'Custom Reason',
  enter_custom_reason: 'Please enter the specific reason',
  not_eligible_for_return: 'Not eligible for return',
  submit_return_request: 'Submit Return Request',

  // Admin Return Requests
  return_request: 'Return Request',
  return_requests: 'Return Requests',
  return_request_page_description:
    'Review and process customer order item return and refund requests',
  return_request_details: 'Return Request Details',
  approve_return_request: 'Approve Return Request',
  approve_transfer_request: 'Approve Transfer Request',
  approve_transfer_request_confirm:
    'Approve this transfer request? The transfer shipment will be booked and the customer notified.',
  reject_transfer_request: 'Reject Transfer Request',
  reject_transfer_request_confirm: 'Reject this transfer request? The customer will be notified.',
  reject_return_request: 'Reject Return Request',
  update_return_status: 'Update Return Status',
  return_tracking_url: 'Return Tracking URL',
  return_tracking_url_placeholder: 'e.g. https://www.ups.com/track?tracknum=...',
  refund_amount: 'Refund Amount',
  admin_notes: 'Admin Notes',
  admin_notes_placeholder: 'Add internal notes or instructions for the customer...',
  rejection_reason: 'Rejection Reason',
  rejection_reason_placeholder: 'State the reason for rejecting this return request...',
  return_completed: 'Return Completed',
  return_requested_status: 'Return Requested',
  return_rejected: 'Return Rejected',
  refund_in_progress: 'Refund In Progress',
  refund_complete: 'Refund Complete',
  customer_photos: 'Customer Photos',
  requested_on: 'Requested On',
  actioned_by: 'Actioned By',
  actioned_on: 'Actioned On',
  return_tracking_url_required: 'Return tracking URL is required',
  refund_amount_required: 'Refund amount is required',
  rejection_reason_required: 'Rejection reason is required',
  accept: 'Accept',
  deny: 'Deny',
  request_status: 'Request Status',
  resolution_details: 'Resolution Details',
  return_item_details: 'Return Item Details',
  no_photos_provided: 'No photos provided by customer',
  return_approved_success: 'Return request approved successfully',
  return_rejected_success: 'Return request rejected successfully',
  return_status_updated_success: 'Return status updated successfully',
  track_return_shipment: 'Track Return Shipment',
  refund_summary: 'Refund Summary',
  item_status: 'Item Status',
  return_tracking: 'Return Tracking',
  awaiting_admin_review: 'Awaiting Vendor / Admin Review',
  return_requested: 'Return Req',
  return_approved: 'Return Approved',
  refunded: 'Refunded',
  refund_requested: 'Refund Req',
  return_status: 'Return Status',
  refund_approved: 'Refund Approved',
  return_in_progress: 'Return / Refund In Progress',
  return: 'Return',
  track_return: 'Track return',
  cannot_unselect_only_address: 'Your only address cannot be unselected',

  // Map location picker
  latitude: 'Latitude',
  longitude: 'Longitude',
  select_on_map: 'Select on Map',
  select_location_on_map: 'Select Location on Map',
  search_location_placeholder: 'Search an address, city or zip code',
  map_pick_hint: 'Click on the map or drag the pin to set the exact location',
  use_this_location: 'Use This Location',
  my_location: 'My Location',
  map_location_outside_usa:
    'Only locations within the USA (including US territories) can be selected, please pick a US location',
  geolocation_not_supported: 'Your browser does not support location access',
  location_permission_denied:
    'Location access is blocked, please allow location permission in your browser',
  current_location_unavailable: 'Unable to get your current location, please try again',
  location_not_found: 'Location not found, please try another point or address',
  map_service_error: 'Google Maps request failed ({{ code }}), please try again later',
  map_zipcode_not_found:
    'Zip code not found for this point, please enter it manually to fill state and city',
  theme: 'Theme Switcher',
  failed_to_fetch_tracking_info: 'Failed to fetch tracking information',
  customer_order_return_note_description:
    '{{ ffl_name }}, the FFL vendor of this product, will review your return request and take the decision. Once actioned, your request will be forwarded to the next step (return approval, return shipment, refund) and you will be informed through a notification and an email at every stage.',
  order_return_note_description:
    '{{ ffl_name }}, the FFL vendor of this product, will review the return request and take the decision. Once actioned, the application will be forwarded for the next step (return approval, return shipment, refund) and the customer will be informed through an in-app notification and an email at every stage.',

  set_delivery_location: 'Set Location',

  alt_text_edit: 'Alt Text Edit',
  alt_text: 'Alt Text',
  alt_text_description:
    "Alt text (text that describes this media) improves accessibility for people who can't see images on web pages, including people who use screen readers or have slow network connections.",
  add_alt_text: 'Add alt text',
  alt_badge: 'ALT',
  alt_text_character_count: '{{count}} / {{max}} characters',
  alt_text_placeholder: 'Describe the product details, angles, and key features...',
  alt_text_writing_tip_title: 'Writing Tip:',
  alt_text_writing_tip:
    'Describe the subject, setting, and any text within the image. Be concise but descriptive. Avoid starting with "Image of..."',
  zoom_in: 'Zoom In',
  zoom_out: 'Zoom Out',
  exit_full_screen: 'Exit Full Screen',
};
